var items = {
  "block.minecraft.acacia_button": "Akacijev gumb",
  "block.minecraft.acacia_door": "Akacijeva vrata",
  "block.minecraft.acacia_fence": "Akacijeva ograja",
  "block.minecraft.acacia_fence_gate": "Akacijeva ograjna vrata",
  "block.minecraft.acacia_hanging_sign": "Akacijev viseči znak",
  "block.minecraft.acacia_leaves": "Akacijevo listje",
  "block.minecraft.acacia_log": "Akacijev hlod",
  "block.minecraft.acacia_planks": "Akacijeve deske",
  "block.minecraft.acacia_pressure_plate": "Akacijeva zaznavna plošča",
  "block.minecraft.acacia_sapling": "Akacijeva sadika",
  "block.minecraft.acacia_shelf": "Akacijeva polica",
  "block.minecraft.acacia_sign": "Akacijeva tabla",
  "block.minecraft.acacia_slab": "Akacijeva plošča",
  "block.minecraft.acacia_stairs": "Akacijeve stopnice",
  "block.minecraft.acacia_trapdoor": "Akacijeva loputa",
  "block.minecraft.acacia_wall_hanging_sign": "Akacijski stenski viseči znak",
  "block.minecraft.acacia_wall_sign": "Akacijeva tabla na zidu",
  "block.minecraft.acacia_wood": "Akacijev les",
  "block.minecraft.activator_rail": "Aktivacijska tirnica",
  "block.minecraft.air": "Zrak",
  "block.minecraft.allium": "Luk",
  "block.minecraft.amethyst_block": "Kocka ametista",
  "block.minecraft.amethyst_cluster": "Grozd ametistov",
  "block.minecraft.ancient_debris": "Starodavne razbitine",
  "block.minecraft.andesite": "Andezit",
  "block.minecraft.andesite_slab": "Andezitna plošča",
  "block.minecraft.andesite_stairs": "Andezitne stopnice",
  "block.minecraft.andesite_wall": "Andezitni zid",
  "block.minecraft.anvil": "Nakovalo",
  "block.minecraft.attached_melon_stem": "Pritrjeno steblo lubenice",
  "block.minecraft.attached_pumpkin_stem": "Pritrjeno bučno steblo",
  "block.minecraft.azalea": "Azaleja",
  "block.minecraft.azalea_leaves": "Azalejino listje",
  "block.minecraft.azure_bluet": "Vijolice",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambusova kocka",
  "block.minecraft.bamboo_button": "Bambusov gumb",
  "block.minecraft.bamboo_door": "Bambusova vrata",
  "block.minecraft.bamboo_fence": "Bambusova ograja",
  "block.minecraft.bamboo_fence_gate": "Bambusova ograjna vrata",
  "block.minecraft.bamboo_hanging_sign": "Bambusov viseči znak",
  "block.minecraft.bamboo_mosaic": "Bambusov mozaik",
  "block.minecraft.bamboo_mosaic_slab": "Plošča iz bambusovega mozaika",
  "block.minecraft.bamboo_mosaic_stairs": "Stopnice iz bambusovega mozaika",
  "block.minecraft.bamboo_planks": "Bambusove deske",
  "block.minecraft.bamboo_pressure_plate": "Bambusova zaznavna plošča",
  "block.minecraft.bamboo_sapling": "Bambusov poganjek",
  "block.minecraft.bamboo_shelf": "Bambusova polica",
  "block.minecraft.bamboo_sign": "Bambusov znak",
  "block.minecraft.bamboo_slab": "Bambusova plošča",
  "block.minecraft.bamboo_stairs": "Bambusove stopnice",
  "block.minecraft.bamboo_trapdoor": "Bambusova loputa",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambusov stenski viseči znak",
  "block.minecraft.bamboo_wall_sign": "Bambusov stenski znak",
  "block.minecraft.banner.base.black": "Popolnoma črno območje",
  "block.minecraft.banner.base.blue": "Popolnoma modro polje",
  "block.minecraft.banner.base.brown": "Popolnoma rjavo polje",
  "block.minecraft.banner.base.cyan": "Popolnoma turkizno polje",
  "block.minecraft.banner.base.gray": "Popolnoma sivo polje",
  "block.minecraft.banner.base.green": "Popolnoma zeleno polje",
  "block.minecraft.banner.base.light_blue": "Popolnoma svetlo modro polje",
  "block.minecraft.banner.base.light_gray": "Popolnoma svetlo sivo polje",
  "block.minecraft.banner.base.lime": "Popolnoma svetlo zeleno polje",
  "block.minecraft.banner.base.magenta": "Popolnoma škrlatno polje",
  "block.minecraft.banner.base.orange": "Popolnoma oranžno polje",
  "block.minecraft.banner.base.pink": "Popolnoma rožnato polje",
  "block.minecraft.banner.base.purple": "Popolnoma vijolično polje",
  "block.minecraft.banner.base.red": "Popolnoma rdeče polje",
  "block.minecraft.banner.base.white": "Popolnoma belo polje",
  "block.minecraft.banner.base.yellow": "Popolnoma rumeno polje",
  "block.minecraft.banner.border.black": "Črna obroba",
  "block.minecraft.banner.border.blue": "Modra obroba",
  "block.minecraft.banner.border.brown": "Rjava obroba",
  "block.minecraft.banner.border.cyan": "Turkizna obroba",
  "block.minecraft.banner.border.gray": "Siva obroba",
  "block.minecraft.banner.border.green": "Zelena obroba",
  "block.minecraft.banner.border.light_blue": "Svetlo modra obroba",
  "block.minecraft.banner.border.light_gray": "Svetlo siva obroba",
  "block.minecraft.banner.border.lime": "Svetlo zelena obroba",
  "block.minecraft.banner.border.magenta": "Škrlatna obroba",
  "block.minecraft.banner.border.orange": "Oranžna obroba",
  "block.minecraft.banner.border.pink": "Roza obroba",
  "block.minecraft.banner.border.purple": "Vijolična obroba",
  "block.minecraft.banner.border.red": "Rdeča obroba",
  "block.minecraft.banner.border.white": "Bela obroba",
  "block.minecraft.banner.border.yellow": "Rumena obroba",
  "block.minecraft.banner.bricks.black": "Črn zid",
  "block.minecraft.banner.bricks.blue": "Moder zid",
  "block.minecraft.banner.bricks.brown": "Rjav zid",
  "block.minecraft.banner.bricks.cyan": "Turkizen zid",
  "block.minecraft.banner.bricks.gray": "Siv zid",
  "block.minecraft.banner.bricks.green": "Zelen zid",
  "block.minecraft.banner.bricks.light_blue": "Svetlo moder zid",
  "block.minecraft.banner.bricks.light_gray": "Svetlo siv zid",
  "block.minecraft.banner.bricks.lime": "Svetlo siv zid",
  "block.minecraft.banner.bricks.magenta": "Škrlaten zid",
  "block.minecraft.banner.bricks.orange": "Oranžen zid",
  "block.minecraft.banner.bricks.pink": "Roza zid",
  "block.minecraft.banner.bricks.purple": "Vijoličen zid",
  "block.minecraft.banner.bricks.red": "Rdeč zid",
  "block.minecraft.banner.bricks.white": "Bel zid",
  "block.minecraft.banner.bricks.yellow": "Rumen zid",
  "block.minecraft.banner.circle.black": "Črn krog",
  "block.minecraft.banner.circle.blue": "Moder krog",
  "block.minecraft.banner.circle.brown": "Rjav krog",
  "block.minecraft.banner.circle.cyan": "Turkizen krog",
  "block.minecraft.banner.circle.gray": "Siv krog",
  "block.minecraft.banner.circle.green": "Zelen krog",
  "block.minecraft.banner.circle.light_blue": "Svetlo moder krog",
  "block.minecraft.banner.circle.light_gray": "Svetlo siv krog",
  "block.minecraft.banner.circle.lime": "Svetlo zelen krog",
  "block.minecraft.banner.circle.magenta": "Škrlaten krog",
  "block.minecraft.banner.circle.orange": "Oranžen krog",
  "block.minecraft.banner.circle.pink": "Roza krog",
  "block.minecraft.banner.circle.purple": "Vijoličen krog",
  "block.minecraft.banner.circle.red": "Rdeč krog",
  "block.minecraft.banner.circle.white": "Bel krog",
  "block.minecraft.banner.circle.yellow": "Rumen krog",
  "block.minecraft.banner.creeper.black": "Črn creeper",
  "block.minecraft.banner.creeper.blue": "Moder creeper",
  "block.minecraft.banner.creeper.brown": "Rjav creeper",
  "block.minecraft.banner.creeper.cyan": "Turkizen creeper",
  "block.minecraft.banner.creeper.gray": "Siv creeper",
  "block.minecraft.banner.creeper.green": "Zelen creeper",
  "block.minecraft.banner.creeper.light_blue": "Svetlo moder creeper",
  "block.minecraft.banner.creeper.light_gray": "Svetlo siv creeper",
  "block.minecraft.banner.creeper.lime": "Svetlo zelen creeper",
  "block.minecraft.banner.creeper.magenta": "Škrlaten creeper",
  "block.minecraft.banner.creeper.orange": "Oranžen creeper",
  "block.minecraft.banner.creeper.pink": "Roza creeper",
  "block.minecraft.banner.creeper.purple": "Vijoličen creeper",
  "block.minecraft.banner.creeper.red": "Rdeč creeper",
  "block.minecraft.banner.creeper.white": "Bel creeper",
  "block.minecraft.banner.creeper.yellow": "Rumen creeper",
  "block.minecraft.banner.cross.black": "Črn andrejev križ",
  "block.minecraft.banner.cross.blue": "Moder andrejev križ",
  "block.minecraft.banner.cross.brown": "Rjav andrejev križ",
  "block.minecraft.banner.cross.cyan": "Turkizen andrejev križ",
  "block.minecraft.banner.cross.gray": "Siv andrejev križ",
  "block.minecraft.banner.cross.green": "Zelen andrejev križ",
  "block.minecraft.banner.cross.light_blue": "Svetlo moder andrejev križ",
  "block.minecraft.banner.cross.light_gray": "Svetlo siv andrejev križ",
  "block.minecraft.banner.cross.lime": "Svetlo zelen andrejev križ",
  "block.minecraft.banner.cross.magenta": "Škrlaten andrejev križ",
  "block.minecraft.banner.cross.orange": "Oranžen andrejev križ",
  "block.minecraft.banner.cross.pink": "Roza andrejev križ",
  "block.minecraft.banner.cross.purple": "Vijoličen andrejev križ",
  "block.minecraft.banner.cross.red": "Rdeč andrejev križ",
  "block.minecraft.banner.cross.white": "Bel andrejev križ",
  "block.minecraft.banner.cross.yellow": "Rumen andrejev križ",
  "block.minecraft.banner.curly_border.black": "Črna zobčasta obroba",
  "block.minecraft.banner.curly_border.blue": "Modra zobčasta obroba",
  "block.minecraft.banner.curly_border.brown": "Rjava zobčasta obroba",
  "block.minecraft.banner.curly_border.cyan": "Turkizna zobčasta obroba",
  "block.minecraft.banner.curly_border.gray": "Siva zobčasta obroba",
  "block.minecraft.banner.curly_border.green": "Zelena zobčasta obroba",
  "block.minecraft.banner.curly_border.light_blue": "Svetlo modra zobčasta obroba",
  "block.minecraft.banner.curly_border.light_gray": "Svetlo siva zobčasta obroba",
  "block.minecraft.banner.curly_border.lime": "Svetlo siva zobčasta obroba",
  "block.minecraft.banner.curly_border.magenta": "Škrlatna zobčasta obroba",
  "block.minecraft.banner.curly_border.orange": "Oranžna zobčasta obroba",
  "block.minecraft.banner.curly_border.pink": "Roza zobčasta obroba",
  "block.minecraft.banner.curly_border.purple": "Vijolična zobčasta obroba",
  "block.minecraft.banner.curly_border.red": "Rdeča zobčasta obroba",
  "block.minecraft.banner.curly_border.white": "Bela zobčasta obroba",
  "block.minecraft.banner.curly_border.yellow": "Rumena zobčasta obroba",
  "block.minecraft.banner.diagonal_left.black": "Črn levo poševno sekani",
  "block.minecraft.banner.diagonal_left.blue": "Moder levo poševno sekani",
  "block.minecraft.banner.diagonal_left.brown": "Rjav levo poševno sekani",
  "block.minecraft.banner.diagonal_left.cyan": "Turkizen levo poševno sekani",
  "block.minecraft.banner.diagonal_left.gray": "Siv levo poševno sekani",
  "block.minecraft.banner.diagonal_left.green": "Zelen levo poševno sekani",
  "block.minecraft.banner.diagonal_left.light_blue": "Svetlo moder levo poševno sekani",
  "block.minecraft.banner.diagonal_left.light_gray": "Svetlo siv levo poševno sekani",
  "block.minecraft.banner.diagonal_left.lime": "Svetlo zelen levo poševno sekani",
  "block.minecraft.banner.diagonal_left.magenta": "Škrlaten levo poševno sekani",
  "block.minecraft.banner.diagonal_left.orange": "Oranžen levo poševno sekani",
  "block.minecraft.banner.diagonal_left.pink": "Roza levo poševno sekani",
  "block.minecraft.banner.diagonal_left.purple": "Vijoličen levo poševno sekani",
  "block.minecraft.banner.diagonal_left.red": "Rdeč levo poševno sekani",
  "block.minecraft.banner.diagonal_left.white": "Bel levo poševno sekani",
  "block.minecraft.banner.diagonal_left.yellow": "Rumen levo poševno sekani",
  "block.minecraft.banner.diagonal_right.black": "Črn poševno sekani",
  "block.minecraft.banner.diagonal_right.blue": "Moder poševno sekani",
  "block.minecraft.banner.diagonal_right.brown": "Rjav poševno sekani",
  "block.minecraft.banner.diagonal_right.cyan": "Turkizen poševno sekani",
  "block.minecraft.banner.diagonal_right.gray": "Siv poševno sekani",
  "block.minecraft.banner.diagonal_right.green": "Zelen poševno sekani",
  "block.minecraft.banner.diagonal_right.light_blue": "Svetlo moder poševno sekani",
  "block.minecraft.banner.diagonal_right.light_gray": "Svetlo siv poševno sekani",
  "block.minecraft.banner.diagonal_right.lime": "Svetlo zelen poševno sekani",
  "block.minecraft.banner.diagonal_right.magenta": "Škrlaten poševno sekani",
  "block.minecraft.banner.diagonal_right.orange": "Oranžen poševno sekani",
  "block.minecraft.banner.diagonal_right.pink": "Roza poševno sekani",
  "block.minecraft.banner.diagonal_right.purple": "Vijoličen poševno sekani",
  "block.minecraft.banner.diagonal_right.red": "Rdeč poševno sekani",
  "block.minecraft.banner.diagonal_right.white": "Bel poševno sekani",
  "block.minecraft.banner.diagonal_right.yellow": "Rumen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.black": "Črn obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.blue": "Moder obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.brown": "Rjav obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.cyan": "Turkizen obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.gray": "Siv obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.green": "Zelen obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Svetlo moder obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Svetlo siv obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.lime": "Svetlo zelen obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.magenta": "Škrlaten obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranžen obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.pink": "Roza obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.purple": "Vijoličen obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.red": "Rdeč obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.white": "Bel obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_left.yellow": "Rumen obrnjen poševno sekani",
  "block.minecraft.banner.diagonal_up_right.black": "Črn obnjen levo poševno sekani",
  "block.minecraft.banner.diagonal_up_right.blue": "Moder obnjen levo poševno sekani",
  "block.minecraft.banner.diagonal_up_right.brown": "Rjav obnjen levo poševno sekani",
  "block.minecraft.banner.diagonal_up_right.cyan": "Turkizen obnjen levo poševno sekani",
  "block.minecraft.banner.diagonal_up_right.gray": "Siv obnjen levo poševno sekani",
  "block.minecraft.banner.diagonal_up_right.green": "Zelen obnjen levo poševno sekani",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Svetlo moder obnjen levo poševno sekani",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Svetlo siv obnjen levo poševno sekani",
  "block.minecraft.banner.diagonal_up_right.lime": "Svetlo zelen obnjen levo poševno sekani",
  "block.minecraft.banner.diagonal_up_right.magenta": "Škrlaten obnjen levo poševno sekani",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranžen obnjen levo poševno sekani",
  "block.minecraft.banner.diagonal_up_right.pink": "Roza obnjen levo poševno sekani",
  "block.minecraft.banner.diagonal_up_right.purple": "Vijoličen obnjen levo poševno sekani",
  "block.minecraft.banner.diagonal_up_right.red": "Rdeč obnjen levo poševno sekani",
  "block.minecraft.banner.diagonal_up_right.white": "Bel obnjen levo poševno sekani",
  "block.minecraft.banner.diagonal_up_right.yellow": "Rumen obnjen levo poševno sekani",
  "block.minecraft.banner.flow.black": "Črn tok",
  "block.minecraft.banner.flow.blue": "Modri tok",
  "block.minecraft.banner.flow.brown": "Rjavi tok",
  "block.minecraft.banner.flow.cyan": "Turkizni tok",
  "block.minecraft.banner.flow.gray": "Sivi Tok",
  "block.minecraft.banner.flow.green": "Zelen Tok",
  "block.minecraft.banner.flow.light_blue": "Svetlo Moder Tok",
  "block.minecraft.banner.flow.light_gray": "Svetlo Siv Tok",
  "block.minecraft.banner.flow.lime": "Svetlo Zelen Tok",
  "block.minecraft.banner.flow.magenta": "Škrlaten Tok",
  "block.minecraft.banner.flow.orange": "Oranžen Tok",
  "block.minecraft.banner.flow.pink": "Rožnati Tok",
  "block.minecraft.banner.flow.purple": "Vijoličen Tok",
  "block.minecraft.banner.flow.red": "Rdeč Tok",
  "block.minecraft.banner.flow.white": "Bel Tok",
  "block.minecraft.banner.flow.yellow": "Rumen Tok",
  "block.minecraft.banner.flower.black": "Črna vrtnica",
  "block.minecraft.banner.flower.blue": "Modra vrtnica",
  "block.minecraft.banner.flower.brown": "Rjava vrtnica",
  "block.minecraft.banner.flower.cyan": "Turkizna vrtnica",
  "block.minecraft.banner.flower.gray": "Siva vrtnica",
  "block.minecraft.banner.flower.green": "Zelena vrtnica",
  "block.minecraft.banner.flower.light_blue": "Svetlo modra vrtnica",
  "block.minecraft.banner.flower.light_gray": "Svetlo siva vrtnica",
  "block.minecraft.banner.flower.lime": "Svetlo zelena vrtnica",
  "block.minecraft.banner.flower.magenta": "Škrlatna vrtnica",
  "block.minecraft.banner.flower.orange": "Oranžna vrtnica",
  "block.minecraft.banner.flower.pink": "Roza vrtnica",
  "block.minecraft.banner.flower.purple": "Vijolična vrtnica",
  "block.minecraft.banner.flower.red": "Rdeča vrtnica",
  "block.minecraft.banner.flower.white": "Bela vrtnica",
  "block.minecraft.banner.flower.yellow": "Rumena vrtnica",
  "block.minecraft.banner.globe.black": "Črn globus",
  "block.minecraft.banner.globe.blue": "Moder globus",
  "block.minecraft.banner.globe.brown": "Rjav globus",
  "block.minecraft.banner.globe.cyan": "Turkizni globus",
  "block.minecraft.banner.globe.gray": "Siv globus",
  "block.minecraft.banner.globe.green": "Zelen globus",
  "block.minecraft.banner.globe.light_blue": "Svetlo moder globus",
  "block.minecraft.banner.globe.light_gray": "Svetlo siv globus",
  "block.minecraft.banner.globe.lime": "Svetlo zelen globus",
  "block.minecraft.banner.globe.magenta": "Škrlaten globus",
  "block.minecraft.banner.globe.orange": "Oranžen globus",
  "block.minecraft.banner.globe.pink": "Roza globus",
  "block.minecraft.banner.globe.purple": "Vijoličen globus",
  "block.minecraft.banner.globe.red": "Rdeč globus",
  "block.minecraft.banner.globe.white": "Bel globus",
  "block.minecraft.banner.globe.yellow": "Rumen globus",
  "block.minecraft.banner.gradient.black": "Črn zgornji gradient",
  "block.minecraft.banner.gradient.blue": "Moder zgornji gradient",
  "block.minecraft.banner.gradient.brown": "Rjav zgornji gradient",
  "block.minecraft.banner.gradient.cyan": "Turkizen zgornji gradient",
  "block.minecraft.banner.gradient.gray": "Siv zgornji gradient",
  "block.minecraft.banner.gradient.green": "Zelen zgornji gradient",
  "block.minecraft.banner.gradient.light_blue": "Svetlo moder zgornji gradient",
  "block.minecraft.banner.gradient.light_gray": "Svetlo siv zgornji gradient",
  "block.minecraft.banner.gradient.lime": "Svetlo zelen zgornji gradient",
  "block.minecraft.banner.gradient.magenta": "Škrlaten zgornji gradient",
  "block.minecraft.banner.gradient.orange": "Oranžen zgornji gradient",
  "block.minecraft.banner.gradient.pink": "Roza zgornji gradient",
  "block.minecraft.banner.gradient.purple": "Vijoličen zgornji gradient",
  "block.minecraft.banner.gradient.red": "Rdeč zgornji gradient",
  "block.minecraft.banner.gradient.white": "Bel zgornji gradient",
  "block.minecraft.banner.gradient.yellow": "Rumen zgornji gradient",
  "block.minecraft.banner.gradient_up.black": "Črn spodnji gradient",
  "block.minecraft.banner.gradient_up.blue": "Moder spodnji gradient",
  "block.minecraft.banner.gradient_up.brown": "Rjav spodnji gradient",
  "block.minecraft.banner.gradient_up.cyan": "Turkizen spodnji gradient",
  "block.minecraft.banner.gradient_up.gray": "Siv spodnji gradient",
  "block.minecraft.banner.gradient_up.green": "Zelen spodnji gradient",
  "block.minecraft.banner.gradient_up.light_blue": "Svetlo moder spodnji gradient",
  "block.minecraft.banner.gradient_up.light_gray": "Svetlo siv spodnji gradient",
  "block.minecraft.banner.gradient_up.lime": "Svetlo zelen spodnji gradient",
  "block.minecraft.banner.gradient_up.magenta": "Škrlaten spodnji gradient",
  "block.minecraft.banner.gradient_up.orange": "Oranžen spodnji gradient",
  "block.minecraft.banner.gradient_up.pink": "Roza spodnji gradient",
  "block.minecraft.banner.gradient_up.purple": "Vijoličen spodnji gradient",
  "block.minecraft.banner.gradient_up.red": "Rdeč spodnji gradient",
  "block.minecraft.banner.gradient_up.white": "Bel spodnji gradient",
  "block.minecraft.banner.gradient_up.yellow": "Rumen spodnji gradient",
  "block.minecraft.banner.guster.black": "Črni Guster",
  "block.minecraft.banner.guster.blue": "Modri Guster",
  "block.minecraft.banner.guster.brown": "Rjavi Guster",
  "block.minecraft.banner.guster.cyan": "Turkizni Guster",
  "block.minecraft.banner.guster.gray": "Sivi Guster",
  "block.minecraft.banner.guster.green": "Zeleni Guster",
  "block.minecraft.banner.guster.light_blue": "Svetlo modri Guster",
  "block.minecraft.banner.guster.light_gray": "Svetlo siv Guster",
  "block.minecraft.banner.guster.lime": "Svetlo zelen Guster",
  "block.minecraft.banner.guster.magenta": "Škrlaten Guster",
  "block.minecraft.banner.guster.orange": "Oranžni Guster",
  "block.minecraft.banner.guster.pink": "Rožnat Guster",
  "block.minecraft.banner.guster.purple": "Vijoličen Guster",
  "block.minecraft.banner.guster.red": "Rdeči Guster",
  "block.minecraft.banner.guster.white": "Bel Guster",
  "block.minecraft.banner.guster.yellow": "Rumen Guster",
  "block.minecraft.banner.half_horizontal.black": "Črn zgornje deljen",
  "block.minecraft.banner.half_horizontal.blue": "Moder zgornje deljen",
  "block.minecraft.banner.half_horizontal.brown": "Rjav zgornje deljen",
  "block.minecraft.banner.half_horizontal.cyan": "Turkizen zgornje deljen",
  "block.minecraft.banner.half_horizontal.gray": "Siv zgornje deljen",
  "block.minecraft.banner.half_horizontal.green": "Zelen zgornje deljen",
  "block.minecraft.banner.half_horizontal.light_blue": "Svetlo moder zgornje deljen",
  "block.minecraft.banner.half_horizontal.light_gray": "Svetlo siv zgornje deljen",
  "block.minecraft.banner.half_horizontal.lime": "Svetlo zelen zgornje deljen",
  "block.minecraft.banner.half_horizontal.magenta": "Škrlaten zgornje deljen",
  "block.minecraft.banner.half_horizontal.orange": "Oranžen zgornje deljen",
  "block.minecraft.banner.half_horizontal.pink": "Roza zgornje deljen",
  "block.minecraft.banner.half_horizontal.purple": "Vijoličen zgornje deljen",
  "block.minecraft.banner.half_horizontal.red": "Rdeč zgornje deljen",
  "block.minecraft.banner.half_horizontal.white": "Bel zgornje deljen",
  "block.minecraft.banner.half_horizontal.yellow": "Rumen zgornje deljen",
  "block.minecraft.banner.half_horizontal_bottom.black": "Črn spodnje deljen",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Moder spodnje deljen",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Rjav spodnje deljen",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Turkizen spodnje deljen",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Siv spodnje deljen",
  "block.minecraft.banner.half_horizontal_bottom.green": "Zelen spodnje deljen",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Svetlo moder spodnje deljen",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Svetlo siv spodnje deljen",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Svetlo zelen spodnje deljen",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Škrlaten spodnje deljen",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oranžen spodnje deljen",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Roza spodnje deljen",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Vijoličen spodnje deljen",
  "block.minecraft.banner.half_horizontal_bottom.red": "Rdeč spodnje deljen",
  "block.minecraft.banner.half_horizontal_bottom.white": "Bel spodnje deljen",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Rumen spodnje deljen",
  "block.minecraft.banner.half_vertical.black": "Črn desno sekan",
  "block.minecraft.banner.half_vertical.blue": "Moder desno sekan",
  "block.minecraft.banner.half_vertical.brown": "Rjav desno sekan",
  "block.minecraft.banner.half_vertical.cyan": "Turkizen desno sekan",
  "block.minecraft.banner.half_vertical.gray": "Siv desno sekan",
  "block.minecraft.banner.half_vertical.green": "Zelen desno sekan",
  "block.minecraft.banner.half_vertical.light_blue": "Svetlo moder desno sekan",
  "block.minecraft.banner.half_vertical.light_gray": "Svetlo siv desno sekan",
  "block.minecraft.banner.half_vertical.lime": "Svetlo zelen desno sekan",
  "block.minecraft.banner.half_vertical.magenta": "Škrlaten desno sekan",
  "block.minecraft.banner.half_vertical.orange": "Oranžen desno sekan",
  "block.minecraft.banner.half_vertical.pink": "Roza desno sekan",
  "block.minecraft.banner.half_vertical.purple": "Vijoličen desno sekan",
  "block.minecraft.banner.half_vertical.red": "Rdeč desno sekan",
  "block.minecraft.banner.half_vertical.white": "Bel desno sekan",
  "block.minecraft.banner.half_vertical.yellow": "Rumen desno sekan",
  "block.minecraft.banner.half_vertical_right.black": "Črn levo sekan",
  "block.minecraft.banner.half_vertical_right.blue": "Moder levo sekan",
  "block.minecraft.banner.half_vertical_right.brown": "Rjav levo sekan",
  "block.minecraft.banner.half_vertical_right.cyan": "Turkizen levo sekan",
  "block.minecraft.banner.half_vertical_right.gray": "Siv levo sekan",
  "block.minecraft.banner.half_vertical_right.green": "Zelen levo sekan",
  "block.minecraft.banner.half_vertical_right.light_blue": "Svetlo moder levo sekan",
  "block.minecraft.banner.half_vertical_right.light_gray": "Svetlo siv levo sekan",
  "block.minecraft.banner.half_vertical_right.lime": "Svetlo zelen levo sekan",
  "block.minecraft.banner.half_vertical_right.magenta": "Škrlaten levo sekan",
  "block.minecraft.banner.half_vertical_right.orange": "Oranžen levo sekan",
  "block.minecraft.banner.half_vertical_right.pink": "Roza levo sekan",
  "block.minecraft.banner.half_vertical_right.purple": "Vijoličen levo sekan",
  "block.minecraft.banner.half_vertical_right.red": "Rdeč levo sekan",
  "block.minecraft.banner.half_vertical_right.white": "Bel levo sekan",
  "block.minecraft.banner.half_vertical_right.yellow": "Rumen levo sekan",
  "block.minecraft.banner.mojang.black": "Črni Mojang znak",
  "block.minecraft.banner.mojang.blue": "Modri Mojang znak",
  "block.minecraft.banner.mojang.brown": "Rjavi Mojang znak",
  "block.minecraft.banner.mojang.cyan": "Turkizni Mojang znak",
  "block.minecraft.banner.mojang.gray": "Sivi Mojang znak",
  "block.minecraft.banner.mojang.green": "Zeleni Mojang znak",
  "block.minecraft.banner.mojang.light_blue": "Svetlo modri Mojang znak",
  "block.minecraft.banner.mojang.light_gray": "Svetlo sivi Mojang znak",
  "block.minecraft.banner.mojang.lime": "Svetlo zeleni Mojang znak",
  "block.minecraft.banner.mojang.magenta": "Škrlaten Mojang znak",
  "block.minecraft.banner.mojang.orange": "Oranžni Mojang znak",
  "block.minecraft.banner.mojang.pink": "Roza Mojang znak",
  "block.minecraft.banner.mojang.purple": "Vijolični Mojang znak",
  "block.minecraft.banner.mojang.red": "Rdeči Mojang znak",
  "block.minecraft.banner.mojang.white": "Beli Mojang znak",
  "block.minecraft.banner.mojang.yellow": "Rumeni Mojang znak",
  "block.minecraft.banner.piglin.black": "Črn rilec",
  "block.minecraft.banner.piglin.blue": "Moder rilec",
  "block.minecraft.banner.piglin.brown": "Rjav rilec",
  "block.minecraft.banner.piglin.cyan": "Turkizen rilec",
  "block.minecraft.banner.piglin.gray": "Siv rilec",
  "block.minecraft.banner.piglin.green": "Zelen rilec",
  "block.minecraft.banner.piglin.light_blue": "Moder rilec",
  "block.minecraft.banner.piglin.light_gray": "Svetlo siv rilec",
  "block.minecraft.banner.piglin.lime": "Svetlo zelen rilec",
  "block.minecraft.banner.piglin.magenta": "Škrlaten rilec",
  "block.minecraft.banner.piglin.orange": "Oranžen rilec",
  "block.minecraft.banner.piglin.pink": "Rožnati rilec",
  "block.minecraft.banner.piglin.purple": "Vijoličen rilec",
  "block.minecraft.banner.piglin.red": "Rdeč rilec",
  "block.minecraft.banner.piglin.white": "Bel rilec",
  "block.minecraft.banner.piglin.yellow": "Rumen rilec",
  "block.minecraft.banner.rhombus.black": "Črn srčni ščit",
  "block.minecraft.banner.rhombus.blue": "Moder srčni ščit",
  "block.minecraft.banner.rhombus.brown": "Rjav srčni ščit",
  "block.minecraft.banner.rhombus.cyan": "Turkizen srčni ščit",
  "block.minecraft.banner.rhombus.gray": "Siv srčni ščit",
  "block.minecraft.banner.rhombus.green": "Zelen srčni ščit",
  "block.minecraft.banner.rhombus.light_blue": "Svetlo moder srčni ščit",
  "block.minecraft.banner.rhombus.light_gray": "Svetlo siv srčni ščit",
  "block.minecraft.banner.rhombus.lime": "Svetlo zelen srčni ščit",
  "block.minecraft.banner.rhombus.magenta": "Škrlaten srčni ščit",
  "block.minecraft.banner.rhombus.orange": "Oranžen srčni ščit",
  "block.minecraft.banner.rhombus.pink": "Roza srčni ščit",
  "block.minecraft.banner.rhombus.purple": "Vijoličen srčni ščit",
  "block.minecraft.banner.rhombus.red": "Rdeč srčni ščit",
  "block.minecraft.banner.rhombus.white": "Bel srčni ščit",
  "block.minecraft.banner.rhombus.yellow": "Rumen srčni ščit",
  "block.minecraft.banner.skull.black": "Črn gusarski znak",
  "block.minecraft.banner.skull.blue": "Moder gusarski znak",
  "block.minecraft.banner.skull.brown": "Rjav gusarski znak",
  "block.minecraft.banner.skull.cyan": "Turkizen gusarski znak",
  "block.minecraft.banner.skull.gray": "Siv gusarski znak",
  "block.minecraft.banner.skull.green": "Zelen gusarski znak",
  "block.minecraft.banner.skull.light_blue": "Svetlo moder gusarski znak",
  "block.minecraft.banner.skull.light_gray": "Svetlo siv gusarski znak",
  "block.minecraft.banner.skull.lime": "Svetlo zelen gusarski znak",
  "block.minecraft.banner.skull.magenta": "Škrlaten gusarski znak",
  "block.minecraft.banner.skull.orange": "Oranžen gusarski znak",
  "block.minecraft.banner.skull.pink": "Roza gusarski znak",
  "block.minecraft.banner.skull.purple": "Vijoličen gusarski znak",
  "block.minecraft.banner.skull.red": "Rdeč gusarski znak",
  "block.minecraft.banner.skull.white": "Bel gusarski znak",
  "block.minecraft.banner.skull.yellow": "Rumen gusarski znak",
  "block.minecraft.banner.small_stripes.black": "Črni stebri",
  "block.minecraft.banner.small_stripes.blue": "Modri stebri",
  "block.minecraft.banner.small_stripes.brown": "Rjavi stebri",
  "block.minecraft.banner.small_stripes.cyan": "Turkizni stebri",
  "block.minecraft.banner.small_stripes.gray": "Sivi stebri",
  "block.minecraft.banner.small_stripes.green": "Zeleni stebri",
  "block.minecraft.banner.small_stripes.light_blue": "Svetlo modri stebri",
  "block.minecraft.banner.small_stripes.light_gray": "Svetlo sivi stebri",
  "block.minecraft.banner.small_stripes.lime": "Svetlo zeleni stebri",
  "block.minecraft.banner.small_stripes.magenta": "Škrlatni stebri",
  "block.minecraft.banner.small_stripes.orange": "Oranžni stebri",
  "block.minecraft.banner.small_stripes.pink": "Roza stebri",
  "block.minecraft.banner.small_stripes.purple": "Vijolični stebri",
  "block.minecraft.banner.small_stripes.red": "Rdeči stebri",
  "block.minecraft.banner.small_stripes.white": "Beli stebri",
  "block.minecraft.banner.small_stripes.yellow": "Rumeni stebri",
  "block.minecraft.banner.square_bottom_left.black": "Črn tretji kvadrat",
  "block.minecraft.banner.square_bottom_left.blue": "Moder tretji kvadrat",
  "block.minecraft.banner.square_bottom_left.brown": "Rjav tretji kvadrat",
  "block.minecraft.banner.square_bottom_left.cyan": "Turkizen tretji kvadrat",
  "block.minecraft.banner.square_bottom_left.gray": "Siv tretji kvadrat",
  "block.minecraft.banner.square_bottom_left.green": "Zelen tretji kvadrat",
  "block.minecraft.banner.square_bottom_left.light_blue": "Svetlo moder tretji kvadrat",
  "block.minecraft.banner.square_bottom_left.light_gray": "Svetlo siv tretji kvadrat",
  "block.minecraft.banner.square_bottom_left.lime": "Svetlo zelen tretji kvadrat",
  "block.minecraft.banner.square_bottom_left.magenta": "Škrlaten tretji kvadrat",
  "block.minecraft.banner.square_bottom_left.orange": "Oranžen tretji kvadrat",
  "block.minecraft.banner.square_bottom_left.pink": "Roza tretji kvadrat",
  "block.minecraft.banner.square_bottom_left.purple": "Vijoličen tretji kvadrat",
  "block.minecraft.banner.square_bottom_left.red": "Rdeč tretji kvadrat",
  "block.minecraft.banner.square_bottom_left.white": "Bel tretji kvadrat",
  "block.minecraft.banner.square_bottom_left.yellow": "Rumen tretji kvadrat",
  "block.minecraft.banner.square_bottom_right.black": "Črn četrti kvadrat",
  "block.minecraft.banner.square_bottom_right.blue": "Moder četrti kvadrat",
  "block.minecraft.banner.square_bottom_right.brown": "Rjav četrti kvadrat",
  "block.minecraft.banner.square_bottom_right.cyan": "Turkizen četrti kvadrat",
  "block.minecraft.banner.square_bottom_right.gray": "Siv četrti kvadrat",
  "block.minecraft.banner.square_bottom_right.green": "Zelen četrti kvadrat",
  "block.minecraft.banner.square_bottom_right.light_blue": "Svetlo moder četrti kvadrat",
  "block.minecraft.banner.square_bottom_right.light_gray": "Svetlo siv četrti kvadrat",
  "block.minecraft.banner.square_bottom_right.lime": "Svetlo zelen četrti kvadrat",
  "block.minecraft.banner.square_bottom_right.magenta": "Škrlaten četrti kvadrat",
  "block.minecraft.banner.square_bottom_right.orange": "Oranžen četrti kvadrat",
  "block.minecraft.banner.square_bottom_right.pink": "Roza četrti kvadrat",
  "block.minecraft.banner.square_bottom_right.purple": "Vijoličen četrti kvadrat",
  "block.minecraft.banner.square_bottom_right.red": "Rdeč četrti kvadrat",
  "block.minecraft.banner.square_bottom_right.white": "Bel četrti kvadrat",
  "block.minecraft.banner.square_bottom_right.yellow": "Rumen četrti kvadrat",
  "block.minecraft.banner.square_top_left.black": "Črn prvi kvadrat",
  "block.minecraft.banner.square_top_left.blue": "Moder prvi kvadrat",
  "block.minecraft.banner.square_top_left.brown": "Rjav prvi kvadrat",
  "block.minecraft.banner.square_top_left.cyan": "Turkizen prvi kvadrat",
  "block.minecraft.banner.square_top_left.gray": "Siv prvi kvadrat",
  "block.minecraft.banner.square_top_left.green": "Zelen prvi kvadrat",
  "block.minecraft.banner.square_top_left.light_blue": "Svetlo moder prvi kvadrat",
  "block.minecraft.banner.square_top_left.light_gray": "Svetlo siv prvi kvadrat",
  "block.minecraft.banner.square_top_left.lime": "Svetlo zelen prvi kvadrat",
  "block.minecraft.banner.square_top_left.magenta": "Škrlaten prvi kvadrat",
  "block.minecraft.banner.square_top_left.orange": "Oranžen prvi kvadrat",
  "block.minecraft.banner.square_top_left.pink": "Roza prvi kvadrat",
  "block.minecraft.banner.square_top_left.purple": "Vijoličen prvi kvadrat",
  "block.minecraft.banner.square_top_left.red": "Rdeč prvi kvadrat",
  "block.minecraft.banner.square_top_left.white": "Bel prvi kvadrat",
  "block.minecraft.banner.square_top_left.yellow": "Rumen prvi kvadrat",
  "block.minecraft.banner.square_top_right.black": "Črn drugi kvadrat",
  "block.minecraft.banner.square_top_right.blue": "Moder drugi kvadrat",
  "block.minecraft.banner.square_top_right.brown": "Rjav drugi kvadrat",
  "block.minecraft.banner.square_top_right.cyan": "Turkizen drugi kvadrat",
  "block.minecraft.banner.square_top_right.gray": "Siv drugi kvadrat",
  "block.minecraft.banner.square_top_right.green": "Zelen drugi kvadrat",
  "block.minecraft.banner.square_top_right.light_blue": "Svetlo moder drugi kvadrat",
  "block.minecraft.banner.square_top_right.light_gray": "Svetlo siv drugi kvadrat",
  "block.minecraft.banner.square_top_right.lime": "Svetlo zelen drugi kvadrat",
  "block.minecraft.banner.square_top_right.magenta": "Škrlaten drugi kvadrat",
  "block.minecraft.banner.square_top_right.orange": "Oranžen drugi kvadrat",
  "block.minecraft.banner.square_top_right.pink": "Roza drugi kvadrat",
  "block.minecraft.banner.square_top_right.purple": "Vijoličen drugi kvadrat",
  "block.minecraft.banner.square_top_right.red": "Rdeč drugi kvadrat",
  "block.minecraft.banner.square_top_right.white": "Bel drugi kvadrat",
  "block.minecraft.banner.square_top_right.yellow": "Rumen drugi kvadrat",
  "block.minecraft.banner.straight_cross.black": "Črn križ",
  "block.minecraft.banner.straight_cross.blue": "Moder križ",
  "block.minecraft.banner.straight_cross.brown": "Rjav križ",
  "block.minecraft.banner.straight_cross.cyan": "Turkizen križ",
  "block.minecraft.banner.straight_cross.gray": "Siv križ",
  "block.minecraft.banner.straight_cross.green": "Zelen križ",
  "block.minecraft.banner.straight_cross.light_blue": "Svetlo moder križ",
  "block.minecraft.banner.straight_cross.light_gray": "Svetlo siv križ",
  "block.minecraft.banner.straight_cross.lime": "Svetlo zelen križ",
  "block.minecraft.banner.straight_cross.magenta": "Škrlaten križ",
  "block.minecraft.banner.straight_cross.orange": "Oranžen križ",
  "block.minecraft.banner.straight_cross.pink": "Roza križ",
  "block.minecraft.banner.straight_cross.purple": "Vijoličen križ",
  "block.minecraft.banner.straight_cross.red": "Rdeč križ",
  "block.minecraft.banner.straight_cross.white": "Bel križ",
  "block.minecraft.banner.straight_cross.yellow": "Rumen križ",
  "block.minecraft.banner.stripe_bottom.black": "Črno dno",
  "block.minecraft.banner.stripe_bottom.blue": "Modro dno",
  "block.minecraft.banner.stripe_bottom.brown": "Rjavo dno",
  "block.minecraft.banner.stripe_bottom.cyan": "Turkizno dno",
  "block.minecraft.banner.stripe_bottom.gray": "Sivo dno",
  "block.minecraft.banner.stripe_bottom.green": "Zeleno dno",
  "block.minecraft.banner.stripe_bottom.light_blue": "Svetlo modro dno",
  "block.minecraft.banner.stripe_bottom.light_gray": "Svetlo sivo dno",
  "block.minecraft.banner.stripe_bottom.lime": "Svetlo zeleno dno",
  "block.minecraft.banner.stripe_bottom.magenta": "Škrlatno dno",
  "block.minecraft.banner.stripe_bottom.orange": "Oranžno dno",
  "block.minecraft.banner.stripe_bottom.pink": "Roza dno",
  "block.minecraft.banner.stripe_bottom.purple": "Vijolično dno",
  "block.minecraft.banner.stripe_bottom.red": "Rdeče dno",
  "block.minecraft.banner.stripe_bottom.white": "Belo dno",
  "block.minecraft.banner.stripe_bottom.yellow": "Rumeno dno",
  "block.minecraft.banner.stripe_center.black": "Črn steber",
  "block.minecraft.banner.stripe_center.blue": "Moder steber",
  "block.minecraft.banner.stripe_center.brown": "Rjav steber",
  "block.minecraft.banner.stripe_center.cyan": "Turkizen steber",
  "block.minecraft.banner.stripe_center.gray": "Siv steber",
  "block.minecraft.banner.stripe_center.green": "Zelen steber",
  "block.minecraft.banner.stripe_center.light_blue": "Svetlo moder steber",
  "block.minecraft.banner.stripe_center.light_gray": "Svetlo siv steber",
  "block.minecraft.banner.stripe_center.lime": "Svetlo zelen steber",
  "block.minecraft.banner.stripe_center.magenta": "Škrlaten steber",
  "block.minecraft.banner.stripe_center.orange": "Oranžen steber",
  "block.minecraft.banner.stripe_center.pink": "Roza steber",
  "block.minecraft.banner.stripe_center.purple": "Vijoličen steber",
  "block.minecraft.banner.stripe_center.red": "Rdeč steber",
  "block.minecraft.banner.stripe_center.white": "Bel steber",
  "block.minecraft.banner.stripe_center.yellow": "Rumen steber",
  "block.minecraft.banner.stripe_downleft.black": "Črna leva lenta",
  "block.minecraft.banner.stripe_downleft.blue": "Modra leva lenta",
  "block.minecraft.banner.stripe_downleft.brown": "Rjava leva lenta",
  "block.minecraft.banner.stripe_downleft.cyan": "Turkizna leva lenta",
  "block.minecraft.banner.stripe_downleft.gray": "Siva leva lenta",
  "block.minecraft.banner.stripe_downleft.green": "Zelena leva lenta",
  "block.minecraft.banner.stripe_downleft.light_blue": "Svetlo modra leva lenta",
  "block.minecraft.banner.stripe_downleft.light_gray": "Svetlo siva leva lenta",
  "block.minecraft.banner.stripe_downleft.lime": "Svetlo zelena leva lenta",
  "block.minecraft.banner.stripe_downleft.magenta": "Škrlatna leva lenta",
  "block.minecraft.banner.stripe_downleft.orange": "Oranžna leva lenta",
  "block.minecraft.banner.stripe_downleft.pink": "Roza leva lenta",
  "block.minecraft.banner.stripe_downleft.purple": "Vijolična leva lenta",
  "block.minecraft.banner.stripe_downleft.red": "Rdeča leva lenta",
  "block.minecraft.banner.stripe_downleft.white": "Bela leva lenta",
  "block.minecraft.banner.stripe_downleft.yellow": "Rumena leva lenta",
  "block.minecraft.banner.stripe_downright.black": "Črna lenta",
  "block.minecraft.banner.stripe_downright.blue": "Modra lenta",
  "block.minecraft.banner.stripe_downright.brown": "Rjava lenta",
  "block.minecraft.banner.stripe_downright.cyan": "Turkizna lenta",
  "block.minecraft.banner.stripe_downright.gray": "Siva lenta",
  "block.minecraft.banner.stripe_downright.green": "Zelena lenta",
  "block.minecraft.banner.stripe_downright.light_blue": "Svetlo modra",
  "block.minecraft.banner.stripe_downright.light_gray": "Svetlo siva lenta",
  "block.minecraft.banner.stripe_downright.lime": "Svetlo zelena lenta",
  "block.minecraft.banner.stripe_downright.magenta": "Škrlatna lenta",
  "block.minecraft.banner.stripe_downright.orange": "Oranžna lenta",
  "block.minecraft.banner.stripe_downright.pink": "Roza lenta",
  "block.minecraft.banner.stripe_downright.purple": "Vijolična lenta",
  "block.minecraft.banner.stripe_downright.red": "Rdeča lenta",
  "block.minecraft.banner.stripe_downright.white": "Bela lenta",
  "block.minecraft.banner.stripe_downright.yellow": "Rumena lenta",
  "block.minecraft.banner.stripe_left.black": "Črn desni bok",
  "block.minecraft.banner.stripe_left.blue": "Moder desni bok",
  "block.minecraft.banner.stripe_left.brown": "Rjav desni bok",
  "block.minecraft.banner.stripe_left.cyan": "Turkizen desni bok",
  "block.minecraft.banner.stripe_left.gray": "Siv desni bok",
  "block.minecraft.banner.stripe_left.green": "Zelen desni bok",
  "block.minecraft.banner.stripe_left.light_blue": "Svetlo moder desni bok",
  "block.minecraft.banner.stripe_left.light_gray": "Svetlo siv desni bok",
  "block.minecraft.banner.stripe_left.lime": "Svetlo zelen desni bok",
  "block.minecraft.banner.stripe_left.magenta": "Škrlaten desni bok",
  "block.minecraft.banner.stripe_left.orange": "Oranžen desni bok",
  "block.minecraft.banner.stripe_left.pink": "Roza desni bok",
  "block.minecraft.banner.stripe_left.purple": "Vijoličen desni bok",
  "block.minecraft.banner.stripe_left.red": "Rdeč desni bok",
  "block.minecraft.banner.stripe_left.white": "Bel desni bok",
  "block.minecraft.banner.stripe_left.yellow": "Rumen desni bok",
  "block.minecraft.banner.stripe_middle.black": "Črn tram",
  "block.minecraft.banner.stripe_middle.blue": "Moder tram",
  "block.minecraft.banner.stripe_middle.brown": "Rjav tram",
  "block.minecraft.banner.stripe_middle.cyan": "Turkizen tram",
  "block.minecraft.banner.stripe_middle.gray": "Siv tram",
  "block.minecraft.banner.stripe_middle.green": "Zelen tram",
  "block.minecraft.banner.stripe_middle.light_blue": "Svetlo moder tram",
  "block.minecraft.banner.stripe_middle.light_gray": "Svetlo siv tram",
  "block.minecraft.banner.stripe_middle.lime": "Svetlo zelen tram",
  "block.minecraft.banner.stripe_middle.magenta": "Škrlaten tram",
  "block.minecraft.banner.stripe_middle.orange": "Oranžen tram",
  "block.minecraft.banner.stripe_middle.pink": "Roza tram",
  "block.minecraft.banner.stripe_middle.purple": "Vijoličen tram",
  "block.minecraft.banner.stripe_middle.red": "Rdeč tram",
  "block.minecraft.banner.stripe_middle.white": "Bel tram",
  "block.minecraft.banner.stripe_middle.yellow": "Rumen tram",
  "block.minecraft.banner.stripe_right.black": "Črn levi bok",
  "block.minecraft.banner.stripe_right.blue": "Moder levi bok",
  "block.minecraft.banner.stripe_right.brown": "Rjav levi bok",
  "block.minecraft.banner.stripe_right.cyan": "Turkizen levi bok",
  "block.minecraft.banner.stripe_right.gray": "Siv levi bok",
  "block.minecraft.banner.stripe_right.green": "Zelen levi bok",
  "block.minecraft.banner.stripe_right.light_blue": "Svetlo moder levi bok",
  "block.minecraft.banner.stripe_right.light_gray": "Svetlo siv levi bok",
  "block.minecraft.banner.stripe_right.lime": "Svetlo zelen levi bok",
  "block.minecraft.banner.stripe_right.magenta": "Škrlaten levi bok",
  "block.minecraft.banner.stripe_right.orange": "Oranžen levi bok",
  "block.minecraft.banner.stripe_right.pink": "Roza levi bok",
  "block.minecraft.banner.stripe_right.purple": "Vijoličen levi bok",
  "block.minecraft.banner.stripe_right.red": "Rdeč levi bok",
  "block.minecraft.banner.stripe_right.white": "Bel levi bok",
  "block.minecraft.banner.stripe_right.yellow": "Rumen levi bok",
  "block.minecraft.banner.stripe_top.black": "Črni vrh",
  "block.minecraft.banner.stripe_top.blue": "Moder vrh",
  "block.minecraft.banner.stripe_top.brown": "Rjav vrh",
  "block.minecraft.banner.stripe_top.cyan": "Turkizen vrh",
  "block.minecraft.banner.stripe_top.gray": "Siv vrh",
  "block.minecraft.banner.stripe_top.green": "Zelen vrh",
  "block.minecraft.banner.stripe_top.light_blue": "Svetlo moder vrh",
  "block.minecraft.banner.stripe_top.light_gray": "Svetlo siv vrh",
  "block.minecraft.banner.stripe_top.lime": "Svetlo zelen vrh",
  "block.minecraft.banner.stripe_top.magenta": "Škrlaten vrh",
  "block.minecraft.banner.stripe_top.orange": "Oranžen vrh",
  "block.minecraft.banner.stripe_top.pink": "Roza vrh",
  "block.minecraft.banner.stripe_top.purple": "Vijoličen vrh",
  "block.minecraft.banner.stripe_top.red": "Rdeč vrh",
  "block.minecraft.banner.stripe_top.white": "Bel vrh",
  "block.minecraft.banner.stripe_top.yellow": "Rumen vrh",
  "block.minecraft.banner.triangle_bottom.black": "Črna škarnica",
  "block.minecraft.banner.triangle_bottom.blue": "Modra škarnica",
  "block.minecraft.banner.triangle_bottom.brown": "Rjava škarnica",
  "block.minecraft.banner.triangle_bottom.cyan": "Turkizna škarnica",
  "block.minecraft.banner.triangle_bottom.gray": "Siva škarnica",
  "block.minecraft.banner.triangle_bottom.green": "Zelena škarnica",
  "block.minecraft.banner.triangle_bottom.light_blue": "Svetlo modra škarnica",
  "block.minecraft.banner.triangle_bottom.light_gray": "Svetlo siva škarnica",
  "block.minecraft.banner.triangle_bottom.lime": "Svetlo zelena škarnica",
  "block.minecraft.banner.triangle_bottom.magenta": "Škrlatna škarnica",
  "block.minecraft.banner.triangle_bottom.orange": "Oranžna škarnica",
  "block.minecraft.banner.triangle_bottom.pink": "Roza škarnica",
  "block.minecraft.banner.triangle_bottom.purple": "Vijolična škarnica",
  "block.minecraft.banner.triangle_bottom.red": "Rdeča škarnica",
  "block.minecraft.banner.triangle_bottom.white": "Bela škarnica",
  "block.minecraft.banner.triangle_bottom.yellow": "Rumena škarnica",
  "block.minecraft.banner.triangle_top.black": "Črna prekucnjena škarnica",
  "block.minecraft.banner.triangle_top.blue": "Modra prekucnjena škarnica",
  "block.minecraft.banner.triangle_top.brown": "Rjava prekucnjena škarnica",
  "block.minecraft.banner.triangle_top.cyan": "Turkizna prekucnjena škarnica",
  "block.minecraft.banner.triangle_top.gray": "Siva prekucnjena škarnica",
  "block.minecraft.banner.triangle_top.green": "Zelena prekucnjena škarnica",
  "block.minecraft.banner.triangle_top.light_blue": "Svetlo modra prekucnjena škarnica",
  "block.minecraft.banner.triangle_top.light_gray": "Svetlo siva prekucnjena škarnica",
  "block.minecraft.banner.triangle_top.lime": "Svetlo zelena prekucnjena škarnica",
  "block.minecraft.banner.triangle_top.magenta": "Škrlatna prekucnjena škarnica",
  "block.minecraft.banner.triangle_top.orange": "Oranžna prekucnjena škarnica",
  "block.minecraft.banner.triangle_top.pink": "Roza prekucnjena škarnica",
  "block.minecraft.banner.triangle_top.purple": "Vijolična prekucnjena škarnica",
  "block.minecraft.banner.triangle_top.red": "Rdeča prekucnjena škarnica",
  "block.minecraft.banner.triangle_top.white": "Bela prekucnjena škarnica",
  "block.minecraft.banner.triangle_top.yellow": "Rumena prekucnjena škarnica",
  "block.minecraft.banner.triangles_bottom.black": "Črna spodnja pokrovača",
  "block.minecraft.banner.triangles_bottom.blue": "Modra spodnja pokrovača",
  "block.minecraft.banner.triangles_bottom.brown": "Rjava spodnja pokrovača",
  "block.minecraft.banner.triangles_bottom.cyan": "Turkizna spodnja pokrovača",
  "block.minecraft.banner.triangles_bottom.gray": "Siva spodnja pokrovača",
  "block.minecraft.banner.triangles_bottom.green": "Zelena spodnja pokrovača",
  "block.minecraft.banner.triangles_bottom.light_blue": "Svetlo modra spodnja pokrovača",
  "block.minecraft.banner.triangles_bottom.light_gray": "Svetlo siva spodnja pokrovača",
  "block.minecraft.banner.triangles_bottom.lime": "Svetlo zelena spodnja pokrovača",
  "block.minecraft.banner.triangles_bottom.magenta": "Škrlatna spodnja pokrovača",
  "block.minecraft.banner.triangles_bottom.orange": "Oranžna spodnja pokrovača",
  "block.minecraft.banner.triangles_bottom.pink": "Roza spodnja pokrovača",
  "block.minecraft.banner.triangles_bottom.purple": "Vijolična spodnja pokrovača",
  "block.minecraft.banner.triangles_bottom.red": "Rdeča spodnja pokrovača",
  "block.minecraft.banner.triangles_bottom.white": "Bela spodnja pokrovača",
  "block.minecraft.banner.triangles_bottom.yellow": "Rumena spodnja pokrovača",
  "block.minecraft.banner.triangles_top.black": "Črna zgornja pokrovača",
  "block.minecraft.banner.triangles_top.blue": "Modra zgornja pokrovača",
  "block.minecraft.banner.triangles_top.brown": "Rjava zgornja pokrovača",
  "block.minecraft.banner.triangles_top.cyan": "Turkizna zgornja pokrovača",
  "block.minecraft.banner.triangles_top.gray": "Siva zgornja pokrovača",
  "block.minecraft.banner.triangles_top.green": "Zelena zgornja pokrovača",
  "block.minecraft.banner.triangles_top.light_blue": "Svetlo modra zgornja pokrovača",
  "block.minecraft.banner.triangles_top.light_gray": "Svetlo siva zgornja pokrovača",
  "block.minecraft.banner.triangles_top.lime": "Svetlo zelena zgornja pokrovača",
  "block.minecraft.banner.triangles_top.magenta": "Škrlatna zgornja pokrovača",
  "block.minecraft.banner.triangles_top.orange": "Oranžna zgornja pokrovača",
  "block.minecraft.banner.triangles_top.pink": "Roza zgornja pokrovača",
  "block.minecraft.banner.triangles_top.purple": "Vijolična zgornja pokrovača",
  "block.minecraft.banner.triangles_top.red": "Rdeča zgornja pokrovača",
  "block.minecraft.banner.triangles_top.white": "Bela zgornja pokrovača",
  "block.minecraft.banner.triangles_top.yellow": "Rumena zgornja pokrovača",
  "block.minecraft.barrel": "Sod",
  "block.minecraft.barrier": "Nevidna pregrada",
  "block.minecraft.basalt": "Bazalt",
  "block.minecraft.beacon": "Svetilnik",
  "block.minecraft.beacon.primary": "Primarna moč",
  "block.minecraft.beacon.secondary": "Sekundarna moč",
  "block.minecraft.bed.no_sleep": "Spiš lahko le ponoči in med nevihtami",
  "block.minecraft.bed.not_safe": "Ne moreš zaspati, ker so v bližini pošasti",
  "block.minecraft.bed.obstructed": "Ta postelja je ovirana",
  "block.minecraft.bed.occupied": "Ta postelja je že zasedena",
  "block.minecraft.bed.too_far_away": "Ne moreš zaspati, ker je postelja predaleč",
  "block.minecraft.bedrock": "Trda skala",
  "block.minecraft.bee_nest": "Čebelje gnezdo",
  "block.minecraft.beehive": "Panj",
  "block.minecraft.beetroots": "Rdeča pesa",
  "block.minecraft.bell": "Zvonec",
  "block.minecraft.big_dripleaf": "Velik kapljični list",
  "block.minecraft.big_dripleaf_stem": "Steblo velikega kapljičnega lista",
  "block.minecraft.birch_button": "Brezov gumb",
  "block.minecraft.birch_door": "Brezova vrata",
  "block.minecraft.birch_fence": "Brezova ograja",
  "block.minecraft.birch_fence_gate": "Brezova ograjna vrata",
  "block.minecraft.birch_hanging_sign": "Brezov Viseči Znak",
  "block.minecraft.birch_leaves": "Brezovo listje",
  "block.minecraft.birch_log": "Brezov hlod",
  "block.minecraft.birch_planks": "Brezove deske",
  "block.minecraft.birch_pressure_plate": "Brezova zaznavna plošča",
  "block.minecraft.birch_sapling": "Brezova sadika",
  "block.minecraft.birch_shelf": "Brezova Polica",
  "block.minecraft.birch_sign": "Brezova tabla",
  "block.minecraft.birch_slab": "Brezova plošča",
  "block.minecraft.birch_stairs": "Brezove stopnice",
  "block.minecraft.birch_trapdoor": "Brezova loputa",
  "block.minecraft.birch_wall_hanging_sign": "Brezni Stenski Viseči Znak",
  "block.minecraft.birch_wall_sign": "Brezova tabla na zidu",
  "block.minecraft.birch_wood": "Brezov les",
  "block.minecraft.black_banner": "Črn prapor",
  "block.minecraft.black_bed": "Črna postelja",
  "block.minecraft.black_candle": "Črna sveča",
  "block.minecraft.black_candle_cake": "Torta s Črno Svečo",
  "block.minecraft.black_carpet": "Črna preproga",
  "block.minecraft.black_concrete": "Črn beton",
  "block.minecraft.black_concrete_powder": "Črn cement",
  "block.minecraft.black_glazed_terracotta": "Črna glazirana terakota",
  "block.minecraft.black_shulker_box": "Črna shulker skrinja",
  "block.minecraft.black_stained_glass": "Črno obarvano steklo",
  "block.minecraft.black_stained_glass_pane": "Črno obarvan vitraž",
  "block.minecraft.black_terracotta": "Črna terakota",
  "block.minecraft.black_wool": "Črna volna",
  "block.minecraft.blackstone": "Črni kamen",
  "block.minecraft.blackstone_slab": "Črna kamnita plošča",
  "block.minecraft.blackstone_stairs": "Črne kamnite stopnice",
  "block.minecraft.blackstone_wall": "Črni kamnit zid",
  "block.minecraft.blast_furnace": "Plavž",
  "block.minecraft.blue_banner": "Moder prapor",
  "block.minecraft.blue_bed": "Modra postelja",
  "block.minecraft.blue_candle": "Modra sveča",
  "block.minecraft.blue_candle_cake": "Torta z Modro Svečo",
  "block.minecraft.blue_carpet": "Modra preproga",
  "block.minecraft.blue_concrete": "Moder beton",
  "block.minecraft.blue_concrete_powder": "Moder cement",
  "block.minecraft.blue_glazed_terracotta": "Modra glazirana terakota",
  "block.minecraft.blue_ice": "Moder led",
  "block.minecraft.blue_orchid": "Modra orhideja",
  "block.minecraft.blue_shulker_box": "Modra shulker skrinja",
  "block.minecraft.blue_stained_glass": "Modro obarvano steklo",
  "block.minecraft.blue_stained_glass_pane": "Modro obarvan vitraž",
  "block.minecraft.blue_terracotta": "Modra terakota",
  "block.minecraft.blue_wool": "Modra volna",
  "block.minecraft.bone_block": "Kostna kocka",
  "block.minecraft.bookshelf": "Knjižna polica",
  "block.minecraft.brain_coral": "Možganska korala",
  "block.minecraft.brain_coral_block": "Kocka možganske korale",
  "block.minecraft.brain_coral_fan": "Veje možganske korale",
  "block.minecraft.brain_coral_wall_fan": "Veje možganske korale na steni",
  "block.minecraft.brewing_stand": "Stojalo za napoje",
  "block.minecraft.brick_slab": "Opečnata plošča",
  "block.minecraft.brick_stairs": "Opečnate stopnice",
  "block.minecraft.brick_wall": "Opečnat zid",
  "block.minecraft.bricks": "Opeke",
  "block.minecraft.brown_banner": "Rjav prapor",
  "block.minecraft.brown_bed": "Rjava postelja",
  "block.minecraft.brown_candle": "Rjava sveča",
  "block.minecraft.brown_candle_cake": "Torta z Rjavo Svečo",
  "block.minecraft.brown_carpet": "Rjava preproga",
  "block.minecraft.brown_concrete": "Rjav beton",
  "block.minecraft.brown_concrete_powder": "Rjav cement",
  "block.minecraft.brown_glazed_terracotta": "Rjava glazirana terakota",
  "block.minecraft.brown_mushroom": "Goban",
  "block.minecraft.brown_mushroom_block": "Kocka gobana",
  "block.minecraft.brown_shulker_box": "Rjava shulker skrinja",
  "block.minecraft.brown_stained_glass": "Rjavo obarvano steklo",
  "block.minecraft.brown_stained_glass_pane": "Rjavo obarvan vitraž",
  "block.minecraft.brown_terracotta": "Rjava terakota",
  "block.minecraft.brown_wool": "Rjava volna",
  "block.minecraft.bubble_column": "Steber mehurčkov",
  "block.minecraft.bubble_coral": "Mehurčkasta korala",
  "block.minecraft.bubble_coral_block": "Kocka mehurčkaste korale",
  "block.minecraft.bubble_coral_fan": "Veje mehurčkaste korale",
  "block.minecraft.bubble_coral_wall_fan": "Veje mehurčkaste korale na steni",
  "block.minecraft.budding_amethyst": "Brsteči Ametist",
  "block.minecraft.bush": "Grm",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusov Cvet",
  "block.minecraft.cake": "Torta",
  "block.minecraft.calcite": "Kalcit",
  "block.minecraft.calibrated_sculk_sensor": "Umerjen Skulk senzor",
  "block.minecraft.campfire": "Taborni ogenj",
  "block.minecraft.candle": "Sveča",
  "block.minecraft.candle_cake": "Torta s Svečami",
  "block.minecraft.carrots": "Korenje",
  "block.minecraft.cartography_table": "Kartografska miza",
  "block.minecraft.carved_pumpkin": "Izrezana buča",
  "block.minecraft.cauldron": "Kotel",
  "block.minecraft.cave_air": "Jamski zrak",
  "block.minecraft.cave_vines": "Jamske ovijalke",
  "block.minecraft.cave_vines_plant": "Jamska ovijalka",
  "block.minecraft.chain": "Železna Veriga",
  "block.minecraft.chain_command_block": "Veriga ukazne kocke",
  "block.minecraft.cherry_button": "Češnjev Gumb",
  "block.minecraft.cherry_door": "Češnjeva Vrata",
  "block.minecraft.cherry_fence": "Češnjeva ograja",
  "block.minecraft.cherry_fence_gate": "Češnjeva ograjna vrata",
  "block.minecraft.cherry_hanging_sign": "Češnjev Viseč Znak",
  "block.minecraft.cherry_leaves": "Češnjevi Listi",
  "block.minecraft.cherry_log": "Češnjev Hlod",
  "block.minecraft.cherry_planks": "Češnjeve deske",
  "block.minecraft.cherry_pressure_plate": "Češnjeva Zaznavna Plošča",
  "block.minecraft.cherry_sapling": "Češnjeva Sadika",
  "block.minecraft.cherry_shelf": "Češnjeva polica",
  "block.minecraft.cherry_sign": "Češnjev znak",
  "block.minecraft.cherry_slab": "Češnjeva plošča",
  "block.minecraft.cherry_stairs": "Češnjeve stopnice",
  "block.minecraft.cherry_trapdoor": "Češnjeva loputa",
  "block.minecraft.cherry_wall_hanging_sign": "Češnjev stenski viseči znak",
  "block.minecraft.cherry_wall_sign": "Češnjev stenski znak",
  "block.minecraft.cherry_wood": "Češnjev les",
  "block.minecraft.chest": "Skrinja",
  "block.minecraft.chipped_anvil": "Okrušeno nakovalo",
  "block.minecraft.chiseled_bookshelf": "Izklesana knjižna polica",
  "block.minecraft.chiseled_copper": "Izklesani baker",
  "block.minecraft.chiseled_deepslate": "Izklesan skrilavec",
  "block.minecraft.chiseled_nether_bricks": "Izklesane peklenske opeke",
  "block.minecraft.chiseled_polished_blackstone": "Izklesan brušen črni kamen",
  "block.minecraft.chiseled_quartz_block": "Izklesan netherni kremen",
  "block.minecraft.chiseled_red_sandstone": "Izklesani rdeči peščenjak",
  "block.minecraft.chiseled_resin_bricks": "Izklesane smolne opeke",
  "block.minecraft.chiseled_sandstone": "Izklesani peščenjak",
  "block.minecraft.chiseled_stone_bricks": "Izklesane kamnite opeke",
  "block.minecraft.chiseled_tuff": "Izklesan lehnjak",
  "block.minecraft.chiseled_tuff_bricks": "Izklesane lehnjakove opeke",
  "block.minecraft.chorus_flower": "Refrenska roža",
  "block.minecraft.chorus_plant": "Refrenska rastlina",
  "block.minecraft.clay": "Glina",
  "block.minecraft.closed_eyeblossom": "Zaprta očesna cvetlica",
  "block.minecraft.coal_block": "Kocka premoga",
  "block.minecraft.coal_ore": "Premogova ruda",
  "block.minecraft.coarse_dirt": "Groba zemlja",
  "block.minecraft.cobbled_deepslate": "Tlakovan skrilavec",
  "block.minecraft.cobbled_deepslate_slab": "Tlakovane ploščice skrilavca",
  "block.minecraft.cobbled_deepslate_stairs": "Tlakovane stopnice skrilavca",
  "block.minecraft.cobbled_deepslate_wall": "Tlakovan zid skrilavca",
  "block.minecraft.cobblestone": "Tlakovec",
  "block.minecraft.cobblestone_slab": "Tlakovana plošča",
  "block.minecraft.cobblestone_stairs": "Tlakovane stopnice",
  "block.minecraft.cobblestone_wall": "Tlakovan zid",
  "block.minecraft.cobweb": "Pajčevina",
  "block.minecraft.cocoa": "Kakav",
  "block.minecraft.command_block": "Ukazna kocka",
  "block.minecraft.comparator": "Redstone primerjalnik",
  "block.minecraft.composter": "Kompostnik",
  "block.minecraft.conduit": "Konduktor",
  "block.minecraft.copper_bars": "Bakrene Rešetke",
  "block.minecraft.copper_block": "Kocka bakra",
  "block.minecraft.copper_bulb": "Bakrena Žarnica",
  "block.minecraft.copper_chain": "Bakrena Veriga",
  "block.minecraft.copper_chest": "Bakrena Skrinja",
  "block.minecraft.copper_door": "Bakrena Vrata",
  "block.minecraft.copper_golem_statue": "Kip Bakrenega Golema",
  "block.minecraft.copper_grate": "Bakrena Rešetka",
  "block.minecraft.copper_lantern": "Bakrena Svetilka",
  "block.minecraft.copper_ore": "Bakrena ruda",
  "block.minecraft.copper_torch": "Bakrena Bakla",
  "block.minecraft.copper_trapdoor": "Bakrena loputa",
  "block.minecraft.copper_wall_torch": "Bakrena Stenska Bakla",
  "block.minecraft.cornflower": "Plavica",
  "block.minecraft.cracked_deepslate_bricks": "Razpokane opeke skrilavca",
  "block.minecraft.cracked_deepslate_tiles": "Razpokane ploščice skrilavca",
  "block.minecraft.cracked_nether_bricks": "Razpokane peklenske opeke",
  "block.minecraft.cracked_polished_blackstone_bricks": "Razpokane brušene črne kamnite opeke",
  "block.minecraft.cracked_stone_bricks": "Razpokane kamnite opeke",
  "block.minecraft.crafter": "Sestavljalnica",
  "block.minecraft.crafting_table": "Delovna miza",
  "block.minecraft.creaking_heart": "Škripajoče srce",
  "block.minecraft.creeper_head": "Creeperjeva glava",
  "block.minecraft.creeper_wall_head": "Creeperjeva glava na steni",
  "block.minecraft.crimson_button": "Krvaveč gumb",
  "block.minecraft.crimson_door": "Krvaveča vrata",
  "block.minecraft.crimson_fence": "Krvaveča ograja",
  "block.minecraft.crimson_fence_gate": "Krvaveča ograjna vrata",
  "block.minecraft.crimson_fungus": "Krvaveča goba",
  "block.minecraft.crimson_hanging_sign": "Krvaveč viseči znak",
  "block.minecraft.crimson_hyphae": "Krvaveče hife",
  "block.minecraft.crimson_nylium": "Krvaveč nilij",
  "block.minecraft.crimson_planks": "Krvaveče deske",
  "block.minecraft.crimson_pressure_plate": "Krvaveča zaznavna plošča",
  "block.minecraft.crimson_roots": "Krvaveče korenine",
  "block.minecraft.crimson_shelf": "Krvaveča Polica",
  "block.minecraft.crimson_sign": "Krvaveča tabla",
  "block.minecraft.crimson_slab": "Krvaveča plošča",
  "block.minecraft.crimson_stairs": "Krvaveče stopnice",
  "block.minecraft.crimson_stem": "Krvaveč bet",
  "block.minecraft.crimson_trapdoor": "Krvaveča loputa",
  "block.minecraft.crimson_wall_hanging_sign": "Krvaveč stenski viseči znak",
  "block.minecraft.crimson_wall_sign": "Krvaveča tabla na zidu",
  "block.minecraft.crying_obsidian": "Jokajoči vulkanski kamen",
  "block.minecraft.cut_copper": "Rezani baker",
  "block.minecraft.cut_copper_slab": "Rezana bakrena plošča",
  "block.minecraft.cut_copper_stairs": "Rezane bakrene stopnice",
  "block.minecraft.cut_red_sandstone": "Rezan rdeči peščenjak",
  "block.minecraft.cut_red_sandstone_slab": "Rezana rdeča peščenjakova plošča",
  "block.minecraft.cut_sandstone": "Rezan peščenjak",
  "block.minecraft.cut_sandstone_slab": "Rezana peščenjakova plošča",
  "block.minecraft.cyan_banner": "Turkizen prapor",
  "block.minecraft.cyan_bed": "Turkizna postelja",
  "block.minecraft.cyan_candle": "Turkizna sveča",
  "block.minecraft.cyan_candle_cake": "Torta s turkizno svečo",
  "block.minecraft.cyan_carpet": "Turkizna preproga",
  "block.minecraft.cyan_concrete": "Turkizen beton",
  "block.minecraft.cyan_concrete_powder": "Turkizen cement",
  "block.minecraft.cyan_glazed_terracotta": "Turkizna glazirana terakota",
  "block.minecraft.cyan_shulker_box": "Turkizna shulker skrinja",
  "block.minecraft.cyan_stained_glass": "Turkizno obarvano steklo",
  "block.minecraft.cyan_stained_glass_pane": "Turkizno obarvan vitraž",
  "block.minecraft.cyan_terracotta": "Turkizna terakota",
  "block.minecraft.cyan_wool": "Turkizna volna",
  "block.minecraft.damaged_anvil": "Poškodovano nakovalo",
  "block.minecraft.dandelion": "Regrat",
  "block.minecraft.dark_oak_button": "Temen hrastov gumb",
  "block.minecraft.dark_oak_door": "Temna hrastova vrata",
  "block.minecraft.dark_oak_fence": "Temna hrastova ograja",
  "block.minecraft.dark_oak_fence_gate": "Temna hrastova ograjna vrata",
  "block.minecraft.dark_oak_hanging_sign": "Temni hrastov viseči znak",
  "block.minecraft.dark_oak_leaves": "Temno hrastovo listje",
  "block.minecraft.dark_oak_log": "Temen hrastov hlod",
  "block.minecraft.dark_oak_planks": "Temne hrastove deske",
  "block.minecraft.dark_oak_pressure_plate": "Temna hrastova zaznavna plošča",
  "block.minecraft.dark_oak_sapling": "Temna hrastova sadika",
  "block.minecraft.dark_oak_shelf": "Temno Hrastova Polica",
  "block.minecraft.dark_oak_sign": "Temna hrastova tabla",
  "block.minecraft.dark_oak_slab": "Temna hrastova plošča",
  "block.minecraft.dark_oak_stairs": "Temne hrastove stopnice",
  "block.minecraft.dark_oak_trapdoor": "Temna hrastova loputa",
  "block.minecraft.dark_oak_wall_hanging_sign": "Temen hrastov stenski viseči znak",
  "block.minecraft.dark_oak_wall_sign": "Temna hrastova tabla na zidu",
  "block.minecraft.dark_oak_wood": "Temen hrastov les",
  "block.minecraft.dark_prismarine": "Temna morska prizma",
  "block.minecraft.dark_prismarine_slab": "Plošča temne morske prizme",
  "block.minecraft.dark_prismarine_stairs": "Stopnice temne morske prizme",
  "block.minecraft.daylight_detector": "Senzor dnevne svetlobe",
  "block.minecraft.dead_brain_coral": "Mrtva možganska korala",
  "block.minecraft.dead_brain_coral_block": "Kocka mrtve možganske korale",
  "block.minecraft.dead_brain_coral_fan": "Mrtve veje možganske korale",
  "block.minecraft.dead_brain_coral_wall_fan": "Mrtve veje možganske korale na steni",
  "block.minecraft.dead_bubble_coral": "Mrtva mehurčkasta korala",
  "block.minecraft.dead_bubble_coral_block": "Kocka mrtve mehurčkaste korale",
  "block.minecraft.dead_bubble_coral_fan": "Mrtve veje mehurčkaste korale",
  "block.minecraft.dead_bubble_coral_wall_fan": "Mrtve veje mehurčkaste korale na steni",
  "block.minecraft.dead_bush": "Mrtev grmiček",
  "block.minecraft.dead_fire_coral": "Mrtva ognjena korala",
  "block.minecraft.dead_fire_coral_block": "Kocka mrtve ognjene korale",
  "block.minecraft.dead_fire_coral_fan": "Mrtve veje ognjene korale",
  "block.minecraft.dead_fire_coral_wall_fan": "Mrtve veje ognjene korale na steni",
  "block.minecraft.dead_horn_coral": "Mrtva rogovita korala",
  "block.minecraft.dead_horn_coral_block": "Kocka mrtve rogovite korale",
  "block.minecraft.dead_horn_coral_fan": "Mrtve veje rogovite korale",
  "block.minecraft.dead_horn_coral_wall_fan": "Mrtve veje rogovite korale na steni",
  "block.minecraft.dead_tube_coral": "Mrtva cevasta korala",
  "block.minecraft.dead_tube_coral_block": "Kocka mrtve cevaste korale",
  "block.minecraft.dead_tube_coral_fan": "Mrtve veje cevaste korale",
  "block.minecraft.dead_tube_coral_wall_fan": "Mrtve veje cevaste korale na steni",
  "block.minecraft.decorated_pot": "Okrašena vaza",
  "block.minecraft.deepslate": "Skrilavec",
  "block.minecraft.deepslate_brick_slab": "Plošča opek skrilavca",
  "block.minecraft.deepslate_brick_stairs": "Stopnice iz opek skrilavca",
  "block.minecraft.deepslate_brick_wall": "Opečni zid skrilavca",
  "block.minecraft.deepslate_bricks": "Opeke skrilavca",
  "block.minecraft.deepslate_coal_ore": "Premogova ruda v skrilavcu",
  "block.minecraft.deepslate_copper_ore": "Bakrena ruda v skrilavcu",
  "block.minecraft.deepslate_diamond_ore": "Diamantna ruda v skrilavcu",
  "block.minecraft.deepslate_emerald_ore": "Smaragdna ruda v skrilavcu",
  "block.minecraft.deepslate_gold_ore": "Zlata ruda v skrilavcu",
  "block.minecraft.deepslate_iron_ore": "Železova ruda v skrilavcu",
  "block.minecraft.deepslate_lapis_ore": "Ruda lazurnega kamna v skrilavcu",
  "block.minecraft.deepslate_redstone_ore": "Redstone ruda v skrilavcu",
  "block.minecraft.deepslate_tile_slab": "Plošča iz ploščic skrilavca",
  "block.minecraft.deepslate_tile_stairs": "Stopnice iz ploščic skrilavca",
  "block.minecraft.deepslate_tile_wall": "Zid iz ploščic skrilavca",
  "block.minecraft.deepslate_tiles": "Ploščice skrilavca",
  "block.minecraft.detector_rail": "Zaznavna tirnica",
  "block.minecraft.diamond_block": "Kocka diamanta",
  "block.minecraft.diamond_ore": "Diamantna ruda",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Dioritna plošča",
  "block.minecraft.diorite_stairs": "Dioritne stopnice",
  "block.minecraft.diorite_wall": "Dioritni zid",
  "block.minecraft.dirt": "Zemlja",
  "block.minecraft.dirt_path": "Zemljska Pot",
  "block.minecraft.dispenser": "Izstreljevalec",
  "block.minecraft.dragon_egg": "Zmajevo jajce",
  "block.minecraft.dragon_head": "Zmajeva glava",
  "block.minecraft.dragon_wall_head": "Zmajeva glava na steni",
  "block.minecraft.dried_ghast": "Posušeni Ghast",
  "block.minecraft.dried_kelp_block": "Kocka posušene alge",
  "block.minecraft.dripstone_block": "Kocka kapnika",
  "block.minecraft.dropper": "Delilnik",
  "block.minecraft.emerald_block": "Kocka smaragda",
  "block.minecraft.emerald_ore": "Smaragdova ruda",
  "block.minecraft.enchanting_table": "Čarobna miza",
  "block.minecraft.end_gateway": "End prehod",
  "block.minecraft.end_portal": "Portal za End",
  "block.minecraft.end_portal_frame": "Okvir portala za End",
  "block.minecraft.end_rod": "End palica",
  "block.minecraft.end_stone": "End kamen",
  "block.minecraft.end_stone_brick_slab": "End kamnita opečnata plošča",
  "block.minecraft.end_stone_brick_stairs": "End kamnite opečnate stopnice",
  "block.minecraft.end_stone_brick_wall": "End kamniti opečnati zid",
  "block.minecraft.end_stone_bricks": "End kamnite opeke",
  "block.minecraft.ender_chest": "Ender skrinja",
  "block.minecraft.exposed_chiseled_copper": "Izpostavljen izklesan baker",
  "block.minecraft.exposed_copper": "Izpostavljen baker",
  "block.minecraft.exposed_copper_bars": "Izpostavljene Bakrene Rešetke",
  "block.minecraft.exposed_copper_bulb": "Izpostavljena bakrena žarnica",
  "block.minecraft.exposed_copper_chain": "Izpostavljena Bakrena Veriga",
  "block.minecraft.exposed_copper_chest": "Izpostavljena Bakrena Skrinja",
  "block.minecraft.exposed_copper_door": "Izpostavljena bakrena vrata",
  "block.minecraft.exposed_copper_golem_statue": "Izpostavljen Kip Bakrenega Golema",
  "block.minecraft.exposed_copper_grate": "Izpostavljena bakrena rešetka",
  "block.minecraft.exposed_copper_lantern": "Izpostavljena Bakrena Svetilka",
  "block.minecraft.exposed_copper_trapdoor": "Izpostavljena bakrena loputa",
  "block.minecraft.exposed_cut_copper": "Izpostavljen rezan baker",
  "block.minecraft.exposed_cut_copper_slab": "Izpostavljena rezana bakrena plošča",
  "block.minecraft.exposed_cut_copper_stairs": "Izpostavljene rezane bakrene stopnice",
  "block.minecraft.exposed_lightning_rod": "Izpostavljen Strelovod",
  "block.minecraft.farmland": "Zorana zemlja",
  "block.minecraft.fern": "Praprot",
  "block.minecraft.fire": "Ogenj",
  "block.minecraft.fire_coral": "Ognjena korala",
  "block.minecraft.fire_coral_block": "Kocka ognjene korale",
  "block.minecraft.fire_coral_fan": "Veje ognjene korale",
  "block.minecraft.fire_coral_wall_fan": "Veje ognjene korale na steni",
  "block.minecraft.firefly_bush": "Grm kresničk",
  "block.minecraft.fletching_table": "Miza za izdelavo puščic",
  "block.minecraft.flower_pot": "Cvetlični lonček",
  "block.minecraft.flowering_azalea": "Cvetoča Azaleja",
  "block.minecraft.flowering_azalea_leaves": "Cvetoče azalejino listje",
  "block.minecraft.frogspawn": "Žabji mrest",
  "block.minecraft.frosted_ice": "Moten led",
  "block.minecraft.furnace": "Peč",
  "block.minecraft.gilded_blackstone": "Pozlačen črni kamen",
  "block.minecraft.glass": "Steklo",
  "block.minecraft.glass_pane": "Vitraž",
  "block.minecraft.glow_lichen": "Svetleči lišaj",
  "block.minecraft.glowstone": "Svetleči kamen",
  "block.minecraft.gold_block": "Kocka zlata",
  "block.minecraft.gold_ore": "Zlata ruda",
  "block.minecraft.golden_dandelion": "Zlati regrat",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Granitna plošča",
  "block.minecraft.granite_stairs": "Granitne stopnice",
  "block.minecraft.granite_wall": "Granitni zid",
  "block.minecraft.grass": "Trava",
  "block.minecraft.grass_block": "Kocka trave",
  "block.minecraft.gravel": "Gramoz",
  "block.minecraft.gray_banner": "Siv prapor",
  "block.minecraft.gray_bed": "Siva postelja",
  "block.minecraft.gray_candle": "Siva sveča",
  "block.minecraft.gray_candle_cake": "Torta, s sivimi svečami",
  "block.minecraft.gray_carpet": "Siva preproga",
  "block.minecraft.gray_concrete": "Siv beton",
  "block.minecraft.gray_concrete_powder": "Siv cement",
  "block.minecraft.gray_glazed_terracotta": "Siva glazirana terakota",
  "block.minecraft.gray_shulker_box": "Siva shulker skrinja",
  "block.minecraft.gray_stained_glass": "Sivo obarvano steklo",
  "block.minecraft.gray_stained_glass_pane": "Sivo obarvan vitraž",
  "block.minecraft.gray_terracotta": "Siva terakota",
  "block.minecraft.gray_wool": "Siva volna",
  "block.minecraft.green_banner": "Zelen prapor",
  "block.minecraft.green_bed": "Zelena postelja",
  "block.minecraft.green_candle": "Zelena sveča",
  "block.minecraft.green_candle_cake": "Torta z zeleno svečo",
  "block.minecraft.green_carpet": "Zelena preproga",
  "block.minecraft.green_concrete": "Zelen beton",
  "block.minecraft.green_concrete_powder": "Zelen cement",
  "block.minecraft.green_glazed_terracotta": "Zelena glazirana terakota",
  "block.minecraft.green_shulker_box": "Zelena shulker skrinja",
  "block.minecraft.green_stained_glass": "Zeleno obarvano steklo",
  "block.minecraft.green_stained_glass_pane": "Zeleno obarvan vitraž",
  "block.minecraft.green_terracotta": "Zelena terakota",
  "block.minecraft.green_wool": "Zelena volna",
  "block.minecraft.grindstone": "Brusni kamen",
  "block.minecraft.hanging_roots": "Viseče korenine",
  "block.minecraft.hay_block": "Bala sena",
  "block.minecraft.heavy_core": "Težko jedro",
  "block.minecraft.heavy_weighted_pressure_plate": "Težja števna zaznavna plošča",
  "block.minecraft.honey_block": "Kocka medu",
  "block.minecraft.honeycomb_block": "Kocka satja",
  "block.minecraft.hopper": "Lijak",
  "block.minecraft.horn_coral": "Rogovita korala",
  "block.minecraft.horn_coral_block": "Kocka rogovite korale",
  "block.minecraft.horn_coral_fan": "Veje rogovite korale",
  "block.minecraft.horn_coral_wall_fan": "Veje rogovite korale na steni",
  "block.minecraft.ice": "Led",
  "block.minecraft.infested_chiseled_stone_bricks": "Okužene izklesane kamnite opeke",
  "block.minecraft.infested_cobblestone": "Okužen tlakovec",
  "block.minecraft.infested_cracked_stone_bricks": "Okužene razpokane kamnite opeke",
  "block.minecraft.infested_deepslate": "Okužen skrilavec",
  "block.minecraft.infested_mossy_stone_bricks": "Okužene poraščene kamnite opeke",
  "block.minecraft.infested_stone": "Okužen kamen",
  "block.minecraft.infested_stone_bricks": "Okužene kamnite opeke",
  "block.minecraft.iron_bars": "Železne rešetke",
  "block.minecraft.iron_block": "Kocka železa",
  "block.minecraft.iron_chain": "Železa veriga",
  "block.minecraft.iron_door": "Železna vrata",
  "block.minecraft.iron_ore": "Železova ruda",
  "block.minecraft.iron_trapdoor": "Železna loputa",
  "block.minecraft.jack_o_lantern": "Svetleča buča",
  "block.minecraft.jigsaw": "Kos sestavljanke",
  "block.minecraft.jukebox": "Gramofon",
  "block.minecraft.jungle_button": "Džungelski gumb",
  "block.minecraft.jungle_door": "Džungelska vrata",
  "block.minecraft.jungle_fence": "Džungelska ograja",
  "block.minecraft.jungle_fence_gate": "Džungelska ograjna vrata",
  "block.minecraft.jungle_hanging_sign": "Džungelski viseči znak",
  "block.minecraft.jungle_leaves": "Džungelsko listje",
  "block.minecraft.jungle_log": "Džungelski hlod",
  "block.minecraft.jungle_planks": "Džungelske deske",
  "block.minecraft.jungle_pressure_plate": "Džungelska zaznavna plošča",
  "block.minecraft.jungle_sapling": "Džungelska sadika",
  "block.minecraft.jungle_shelf": "Džungelska Polica",
  "block.minecraft.jungle_sign": "Džungelska tabla",
  "block.minecraft.jungle_slab": "Džungelska plošča",
  "block.minecraft.jungle_stairs": "Džungelske stopnice",
  "block.minecraft.jungle_trapdoor": "Džungelska loputa",
  "block.minecraft.jungle_wall_hanging_sign": "Džungelski stenski viseči znak",
  "block.minecraft.jungle_wall_sign": "Džungelska tabla na zidu",
  "block.minecraft.jungle_wood": "Džungelski les",
  "block.minecraft.kelp": "Alga",
  "block.minecraft.kelp_plant": "Steblo alge",
  "block.minecraft.ladder": "Lestev",
  "block.minecraft.lantern": "Svetilka",
  "block.minecraft.lapis_block": "Kocka lapis lazulija",
  "block.minecraft.lapis_ore": "Ruda lazurnega kamna",
  "block.minecraft.large_amethyst_bud": "Velik brst ametista",
  "block.minecraft.large_fern": "Veliki praprot",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Kotel Lave",
  "block.minecraft.leaf_litter": "Listje na tleh",
  "block.minecraft.lectern": "Stojalo za knjigo",
  "block.minecraft.lever": "Ročica",
  "block.minecraft.light": "Svetloba",
  "block.minecraft.light_blue_banner": "Svetlo moder prapor",
  "block.minecraft.light_blue_bed": "Svetlo modra postelja",
  "block.minecraft.light_blue_candle": "Svetlo modra sveča",
  "block.minecraft.light_blue_candle_cake": "Torta z belo svečo",
  "block.minecraft.light_blue_carpet": "Svetlo modra preproga",
  "block.minecraft.light_blue_concrete": "Svetlo moder beton",
  "block.minecraft.light_blue_concrete_powder": "Svetlo moder cement",
  "block.minecraft.light_blue_glazed_terracotta": "Svetlo modra glazirana terakota",
  "block.minecraft.light_blue_shulker_box": "Svetlo modra shulker skrinja",
  "block.minecraft.light_blue_stained_glass": "Svetlo modro obarvano steklo",
  "block.minecraft.light_blue_stained_glass_pane": "Svetlo modro obarvan vitraž",
  "block.minecraft.light_blue_terracotta": "Svetlo modra terakota",
  "block.minecraft.light_blue_wool": "Svetlo modra volna",
  "block.minecraft.light_gray_banner": "Svetlo siv prapor",
  "block.minecraft.light_gray_bed": "Svetlo siva postelja",
  "block.minecraft.light_gray_candle": "Svetlo siva sveča",
  "block.minecraft.light_gray_candle_cake": "Torta s svetlo sivo svečo",
  "block.minecraft.light_gray_carpet": "Svetlo siva preproga",
  "block.minecraft.light_gray_concrete": "Svetlo siv beton",
  "block.minecraft.light_gray_concrete_powder": "Svetlo siv cement",
  "block.minecraft.light_gray_glazed_terracotta": "Svetlo siva glazirana terakota",
  "block.minecraft.light_gray_shulker_box": "Svetlo siva shulker skrinja",
  "block.minecraft.light_gray_stained_glass": "Svetlo sivo obarvano steklo",
  "block.minecraft.light_gray_stained_glass_pane": "Svetlo sivo obarvan vitraž",
  "block.minecraft.light_gray_terracotta": "Svetlo siva terakota",
  "block.minecraft.light_gray_wool": "Svetlo siva volna",
  "block.minecraft.light_weighted_pressure_plate": "Lažja števna zaznavna plošča",
  "block.minecraft.lightning_rod": "Strelovod",
  "block.minecraft.lilac": "Španski bezeg",
  "block.minecraft.lily_of_the_valley": "Šmarnica",
  "block.minecraft.lily_pad": "Lokvanj",
  "block.minecraft.lime_banner": "Svetlo zelen prapor",
  "block.minecraft.lime_bed": "Svetlo zelena postelja",
  "block.minecraft.lime_candle": "Svetlo zelena sveča",
  "block.minecraft.lime_candle_cake": "Torta s svetlo zeleno svečo",
  "block.minecraft.lime_carpet": "Svetlo zelena preproga",
  "block.minecraft.lime_concrete": "Svetlo zelen beton",
  "block.minecraft.lime_concrete_powder": "Svetlo zelen cement",
  "block.minecraft.lime_glazed_terracotta": "Svetlo zelena glazirana terakota",
  "block.minecraft.lime_shulker_box": "Svetlo zelena shulker skrinja",
  "block.minecraft.lime_stained_glass": "Svetlo zeleno obarvano steklo",
  "block.minecraft.lime_stained_glass_pane": "Svetlo zeleno obarvan vitraž",
  "block.minecraft.lime_terracotta": "Svetlo zelena terakota",
  "block.minecraft.lime_wool": "Svetlo zelena volna",
  "block.minecraft.lodestone": "Magnetit",
  "block.minecraft.loom": "Statve",
  "block.minecraft.magenta_banner": "Škrlaten prapor",
  "block.minecraft.magenta_bed": "Škrlatna postelja",
  "block.minecraft.magenta_candle": "Škrlatna sveča",
  "block.minecraft.magenta_candle_cake": "Torta, s škrlatnimi svečami",
  "block.minecraft.magenta_carpet": "Škrlatna preproga",
  "block.minecraft.magenta_concrete": "Škrlaten beton",
  "block.minecraft.magenta_concrete_powder": "Škrlaten cement",
  "block.minecraft.magenta_glazed_terracotta": "Škrlatna glazirana terakota",
  "block.minecraft.magenta_shulker_box": "Škrlatna shulker skrinja",
  "block.minecraft.magenta_stained_glass": "Škrlatno obarvano steklo",
  "block.minecraft.magenta_stained_glass_pane": "Škrlatno obarvan vitraž",
  "block.minecraft.magenta_terracotta": "Škrlatna terakota",
  "block.minecraft.magenta_wool": "Škrlatna volna",
  "block.minecraft.magma_block": "Kocka magme",
  "block.minecraft.mangrove_button": "Mangrov gumb",
  "block.minecraft.mangrove_door": "Mangrova vrata",
  "block.minecraft.mangrove_fence": "Mangrova ograja",
  "block.minecraft.mangrove_fence_gate": "Mangrova ograjna vrata",
  "block.minecraft.mangrove_hanging_sign": "Mangrovov viseči znak",
  "block.minecraft.mangrove_leaves": "Mangrovo listje",
  "block.minecraft.mangrove_log": "Mangrovo deblo",
  "block.minecraft.mangrove_planks": "Mangrove deske",
  "block.minecraft.mangrove_pressure_plate": "Mangrova pohodna plošča",
  "block.minecraft.mangrove_propagule": "Mangrova propagula",
  "block.minecraft.mangrove_roots": "Mangrove korenine",
  "block.minecraft.mangrove_shelf": "Mangrova Polica",
  "block.minecraft.mangrove_sign": "Mangrova tabla",
  "block.minecraft.mangrove_slab": "Mangrova plošča",
  "block.minecraft.mangrove_stairs": "Mangrove stopnice",
  "block.minecraft.mangrove_trapdoor": "Mangrova loputa",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrovski stenski viseči znak",
  "block.minecraft.mangrove_wall_sign": "Mangrova stenska tabla",
  "block.minecraft.mangrove_wood": "Mangrov les",
  "block.minecraft.medium_amethyst_bud": "Srednji brst ametista",
  "block.minecraft.melon": "Lubenica",
  "block.minecraft.melon_stem": "Steblo lubenice",
  "block.minecraft.moss_block": "Kocka mahu",
  "block.minecraft.moss_carpet": "Preproga iz maha",
  "block.minecraft.mossy_cobblestone": "Poraščen tlakovec",
  "block.minecraft.mossy_cobblestone_slab": "Poraščena tlakovana plošča",
  "block.minecraft.mossy_cobblestone_stairs": "Poraščene tlakovane stopnice",
  "block.minecraft.mossy_cobblestone_wall": "Poraščen tlakovan zid",
  "block.minecraft.mossy_stone_brick_slab": "Poraščena kamnita opečnata plošča",
  "block.minecraft.mossy_stone_brick_stairs": "Poraščene kamnite opečnate stopnice",
  "block.minecraft.mossy_stone_brick_wall": "Poraščen kamnit opečnat zid",
  "block.minecraft.mossy_stone_bricks": "Poraščene kamnite opeke",
  "block.minecraft.moving_piston": "Premikajoč bat",
  "block.minecraft.mud": "Blato",
  "block.minecraft.mud_brick_slab": "Blatne opečne stopnice",
  "block.minecraft.mud_brick_stairs": "Blatne opečne stopnice",
  "block.minecraft.mud_brick_wall": "Blaten opečnat zid",
  "block.minecraft.mud_bricks": "Blatne opeke",
  "block.minecraft.muddy_mangrove_roots": "Blatne Mangrove Korenine",
  "block.minecraft.mushroom_stem": "Gobji bet",
  "block.minecraft.mycelium": "Micelij",
  "block.minecraft.nether_brick_fence": "Netherna opečnata ograja",
  "block.minecraft.nether_brick_slab": "Netherna opečnata plošča",
  "block.minecraft.nether_brick_stairs": "Netherne opečnate stopnice",
  "block.minecraft.nether_brick_wall": "Netherni opečnati zid",
  "block.minecraft.nether_bricks": "Netherne opeke",
  "block.minecraft.nether_gold_ore": "Netherna zlata ruda",
  "block.minecraft.nether_portal": "Nether Portal",
  "block.minecraft.nether_quartz_ore": "Ruda nethernega kremena",
  "block.minecraft.nether_sprouts": "Peklenski kalčki",
  "block.minecraft.nether_wart": "Netherna bradavica",
  "block.minecraft.nether_wart_block": "Kocka nethernih bradavic",
  "block.minecraft.netherite_block": "Kocka netherita",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Glasbena kocka",
  "block.minecraft.oak_button": "Hrastov gumb",
  "block.minecraft.oak_door": "Hrastova vrata",
  "block.minecraft.oak_fence": "Hrastova ograja",
  "block.minecraft.oak_fence_gate": "Hrastova ograjna vrata",
  "block.minecraft.oak_hanging_sign": "Hrastov viseči znak",
  "block.minecraft.oak_leaves": "Hrastovo listje",
  "block.minecraft.oak_log": "Hrastov hlod",
  "block.minecraft.oak_planks": "Hrastove deske",
  "block.minecraft.oak_pressure_plate": "Hrastova zaznavna plošča",
  "block.minecraft.oak_sapling": "Hrastova sadika",
  "block.minecraft.oak_shelf": "Hrastova Polica",
  "block.minecraft.oak_sign": "Hrastova tabla",
  "block.minecraft.oak_slab": "Hrastova plošča",
  "block.minecraft.oak_stairs": "Hrastove stopnice",
  "block.minecraft.oak_trapdoor": "Hrastova loputa",
  "block.minecraft.oak_wall_hanging_sign": "Hrastova stenska viseča tabla",
  "block.minecraft.oak_wall_sign": "Hrastova tabla na zidu",
  "block.minecraft.oak_wood": "Hrastov les",
  "block.minecraft.observer": "Opazovalec",
  "block.minecraft.obsidian": "Vulkanski kamen",
  "block.minecraft.ochre_froglight": "Oker žabja luč",
  "block.minecraft.ominous_banner": "Zlovešč prapor",
  "block.minecraft.open_eyeblossom": "Odprta očesna cvetlica",
  "block.minecraft.orange_banner": "Oranžen prapor",
  "block.minecraft.orange_bed": "Oranžna postelja",
  "block.minecraft.orange_candle": "Oranžna sveča",
  "block.minecraft.orange_candle_cake": "Torta z oranžno svečo",
  "block.minecraft.orange_carpet": "Oranžna preproga",
  "block.minecraft.orange_concrete": "Oranžen beton",
  "block.minecraft.orange_concrete_powder": "Oranžen cement",
  "block.minecraft.orange_glazed_terracotta": "Oranžna glazirana terakota",
  "block.minecraft.orange_shulker_box": "Oranžna shulker skrinja",
  "block.minecraft.orange_stained_glass": "Oranžno obarvano steklo",
  "block.minecraft.orange_stained_glass_pane": "Oranžno obarvan vitraž",
  "block.minecraft.orange_terracotta": "Oranžna terakota",
  "block.minecraft.orange_tulip": "Oranžni tulipan",
  "block.minecraft.orange_wool": "Oranžna volna",
  "block.minecraft.oxeye_daisy": "Marjetica",
  "block.minecraft.oxidized_chiseled_copper": "Oksidiran izklesan baker",
  "block.minecraft.oxidized_copper": "Oksidiran baker",
  "block.minecraft.oxidized_copper_bars": "Oksidirane Bakrene Rešetke",
  "block.minecraft.oxidized_copper_bulb": "Oksidirana bakrena žarnica",
  "block.minecraft.oxidized_copper_chain": "Oksidirana Bakrena Veriga",
  "block.minecraft.oxidized_copper_chest": "Oksidirana Bakrena Skrinja",
  "block.minecraft.oxidized_copper_door": "Oksidirana bakrena vrata",
  "block.minecraft.oxidized_copper_golem_statue": "Oksidiran Kip Bakrenega Golema",
  "block.minecraft.oxidized_copper_grate": "Oksidirana bakrena rešetka",
  "block.minecraft.oxidized_copper_lantern": "Oksidirana Bakrena Svetilka",
  "block.minecraft.oxidized_copper_trapdoor": "Oksidirana bakrena loputa",
  "block.minecraft.oxidized_cut_copper": "Oksidiran rezan baker",
  "block.minecraft.oxidized_cut_copper_slab": "Oksidirana rezana bakrena plošča",
  "block.minecraft.oxidized_cut_copper_stairs": "Oksidirane rezane bakrene stopnice",
  "block.minecraft.oxidized_lightning_rod": "Oksidiran Strelovod",
  "block.minecraft.packed_ice": "Strnjen led",
  "block.minecraft.packed_mud": "Stisnjeno blato",
  "block.minecraft.pale_hanging_moss": "Bled viseči mah",
  "block.minecraft.pale_moss_block": "Kocka bledega mahu",
  "block.minecraft.pale_moss_carpet": "Preproga bledega mahu",
  "block.minecraft.pale_oak_button": "Bledi hrastov gumb",
  "block.minecraft.pale_oak_door": "Bleda hrastova vrata",
  "block.minecraft.pale_oak_fence": "Bledi hrastov plot",
  "block.minecraft.pale_oak_fence_gate": "Bledi hrastov vrata",
  "block.minecraft.pale_oak_hanging_sign": "Viseči znak iz bledega hrasta",
  "block.minecraft.pale_oak_leaves": "Bledi hrastovi listi",
  "block.minecraft.pale_oak_log": "Bled hrastov hlod",
  "block.minecraft.pale_oak_planks": "Blede hrastove deske",
  "block.minecraft.pale_oak_pressure_plate": "Bledi hrastov tlačna plošča",
  "block.minecraft.pale_oak_sapling": "Bledi hrastov sadik",
  "block.minecraft.pale_oak_shelf": "Bleda Hrastova Polica",
  "block.minecraft.pale_oak_sign": "Bledi hrastov znak",
  "block.minecraft.pale_oak_slab": "Bleda hrastova plošča",
  "block.minecraft.pale_oak_stairs": "Bledi hrastovi stopi",
  "block.minecraft.pale_oak_trapdoor": "Bleda hrastova loputa",
  "block.minecraft.pale_oak_wall_hanging_sign": "Temen hrastov stenski viseči znak",
  "block.minecraft.pale_oak_wall_sign": "Stenski znak iz bledega hrasta",
  "block.minecraft.pale_oak_wood": "Les bledega hrasta",
  "block.minecraft.pearlescent_froglight": "Biserna žabja luč",
  "block.minecraft.peony": "Potonika",
  "block.minecraft.petrified_oak_slab": "Okamenela hrastova plošča",
  "block.minecraft.piglin_head": "Piglinova glava",
  "block.minecraft.piglin_wall_head": "Piglinova stenska glava",
  "block.minecraft.pink_banner": "Roza prapor",
  "block.minecraft.pink_bed": "Roza postelja",
  "block.minecraft.pink_candle": "Roza sveča",
  "block.minecraft.pink_candle_cake": "Torta z roza svečo",
  "block.minecraft.pink_carpet": "Roza preproga",
  "block.minecraft.pink_concrete": "Roza beton",
  "block.minecraft.pink_concrete_powder": "Roza cement",
  "block.minecraft.pink_glazed_terracotta": "Roza glazirana terakota",
  "block.minecraft.pink_petals": "Rožnati cvetovi",
  "block.minecraft.pink_shulker_box": "Roza shulker skrinja",
  "block.minecraft.pink_stained_glass": "Roza obarvano steklo",
  "block.minecraft.pink_stained_glass_pane": "Roza obarvan vitraž",
  "block.minecraft.pink_terracotta": "Roza terakota",
  "block.minecraft.pink_tulip": "Roza tulipan",
  "block.minecraft.pink_wool": "Roza volna",
  "block.minecraft.piston": "Bat",
  "block.minecraft.piston_head": "Batova glava",
  "block.minecraft.pitcher_crop": "Pridelek vrčnice",
  "block.minecraft.pitcher_plant": "Vrčnica",
  "block.minecraft.player_head": "Igralčeva glava",
  "block.minecraft.player_head.named": "Glava od %s",
  "block.minecraft.player_wall_head": "Igralčeva glava na steni",
  "block.minecraft.podzol": "Podrast",
  "block.minecraft.pointed_dripstone": "Špičasti kapnik",
  "block.minecraft.polished_andesite": "Brušen andezit",
  "block.minecraft.polished_andesite_slab": "Brušena andezitna plošča",
  "block.minecraft.polished_andesite_stairs": "Brušene andezitne stopnice",
  "block.minecraft.polished_basalt": "Brušen bazalt",
  "block.minecraft.polished_blackstone": "Brušen črni kamen",
  "block.minecraft.polished_blackstone_brick_slab": "Brušena črna kamnita opečnata plošča",
  "block.minecraft.polished_blackstone_brick_stairs": "Brušene črne kamnite opečnate stopnice",
  "block.minecraft.polished_blackstone_brick_wall": "Brušen črni kamnit opečnat zid",
  "block.minecraft.polished_blackstone_bricks": "Brušene črne kamnite opeke",
  "block.minecraft.polished_blackstone_button": "Brušen črni kamnit gumb",
  "block.minecraft.polished_blackstone_pressure_plate": "Brušena črna kamnita zaznavna plošča",
  "block.minecraft.polished_blackstone_slab": "Brušena črna kamnita plošča",
  "block.minecraft.polished_blackstone_stairs": "Brušene črne kamnite stopnice",
  "block.minecraft.polished_blackstone_wall": "Brušen črni kamnit zid",
  "block.minecraft.polished_deepslate": "Poliran skrilavec",
  "block.minecraft.polished_deepslate_slab": "Polirana plošča skrilavca",
  "block.minecraft.polished_deepslate_stairs": "Polirane stopnice skrilavca",
  "block.minecraft.polished_deepslate_wall": "Poliran zid skrilavca",
  "block.minecraft.polished_diorite": "Brušen diorit",
  "block.minecraft.polished_diorite_slab": "Brušena dioritna plošča",
  "block.minecraft.polished_diorite_stairs": "Brušene dioritne stopnice",
  "block.minecraft.polished_granite": "Brušen granit",
  "block.minecraft.polished_granite_slab": "Brušena granitna plošča",
  "block.minecraft.polished_granite_stairs": "Brušene granitne stopnice",
  "block.minecraft.polished_tuff": "Poliran lehnjak",
  "block.minecraft.polished_tuff_slab": "Polirana plošča lehnjaka",
  "block.minecraft.polished_tuff_stairs": "Polirane stopnice iz lehnjaka",
  "block.minecraft.polished_tuff_wall": "Poliran lehnjakov zid",
  "block.minecraft.poppy": "Mak",
  "block.minecraft.potatoes": "Krompir",
  "block.minecraft.potted_acacia_sapling": "Posajena akacijeva sadika",
  "block.minecraft.potted_allium": "Posajen luk",
  "block.minecraft.potted_azalea_bush": "Azaleja v loncu",
  "block.minecraft.potted_azure_bluet": "Posajene vijolice",
  "block.minecraft.potted_bamboo": "Posajen bambus",
  "block.minecraft.potted_birch_sapling": "Posajena brezova sadika",
  "block.minecraft.potted_blue_orchid": "Posajena modra orhideja",
  "block.minecraft.potted_brown_mushroom": "Posajen goban",
  "block.minecraft.potted_cactus": "Posajen kaktus",
  "block.minecraft.potted_cherry_sapling": "Posajena češnjeva sadika",
  "block.minecraft.potted_closed_eyeblossom": "Zaprta očesna cvetlica",
  "block.minecraft.potted_cornflower": "Posajena plavica",
  "block.minecraft.potted_crimson_fungus": "Posajena krvaveča goba",
  "block.minecraft.potted_crimson_roots": "Posajene krvaveče korenine",
  "block.minecraft.potted_dandelion": "Posajen regrat",
  "block.minecraft.potted_dark_oak_sapling": "Posajena temna hrastova sadika",
  "block.minecraft.potted_dead_bush": "Posajen mrtev grmiček",
  "block.minecraft.potted_fern": "Posajena praprot",
  "block.minecraft.potted_flowering_azalea_bush": "Cvetoča azaleja v loncu",
  "block.minecraft.potted_golden_dandelion": "Zlati regrat v loncu",
  "block.minecraft.potted_jungle_sapling": "Posajena džungelska sadika",
  "block.minecraft.potted_lily_of_the_valley": "Posajena šmarnica",
  "block.minecraft.potted_mangrove_propagule": "Propagula mangrove v lončku",
  "block.minecraft.potted_oak_sapling": "Posajena hrastova sadika",
  "block.minecraft.potted_open_eyeblossom": "Zaprta očesna cvetlica",
  "block.minecraft.potted_orange_tulip": "Posajen oranžni tulipan",
  "block.minecraft.potted_oxeye_daisy": "Posajena marjetica",
  "block.minecraft.potted_pale_oak_sapling": "Sadika svetlega hrasta v lončkih",
  "block.minecraft.potted_pink_tulip": "Posajen roza tulipan",
  "block.minecraft.potted_poppy": "Posajen mak",
  "block.minecraft.potted_red_mushroom": "Posajena golobica",
  "block.minecraft.potted_red_tulip": "Posajen rdeči tulipan",
  "block.minecraft.potted_spruce_sapling": "Posajena smrekova sadika",
  "block.minecraft.potted_torchflower": "Posajen baklin cvet",
  "block.minecraft.potted_warped_fungus": "Posajena popačena goba",
  "block.minecraft.potted_warped_roots": "Posajene popačene korenine",
  "block.minecraft.potted_white_tulip": "Posajen beli tulipan",
  "block.minecraft.potted_wither_rose": "Posajena wither vrtnica",
  "block.minecraft.powder_snow": "Sneg v prahu",
  "block.minecraft.powder_snow_cauldron": "Kotel s prašnim snegom",
  "block.minecraft.powered_rail": "Električna tirnica",
  "block.minecraft.prismarine": "Morska prizma",
  "block.minecraft.prismarine_brick_slab": "Plošča opeke morske prizme",
  "block.minecraft.prismarine_brick_stairs": "Stopnice opeke morske prizme",
  "block.minecraft.prismarine_bricks": "Opeke morske prizme",
  "block.minecraft.prismarine_slab": "Plošča morske prizme",
  "block.minecraft.prismarine_stairs": "Stopnice morske prizme",
  "block.minecraft.prismarine_wall": "Zid morske prizme",
  "block.minecraft.pumpkin": "Buča",
  "block.minecraft.pumpkin_stem": "Bučna stebla",
  "block.minecraft.purple_banner": "Vijoličen prapor",
  "block.minecraft.purple_bed": "Vijolična postelja",
  "block.minecraft.purple_candle": "Vijolična sveča",
  "block.minecraft.purple_candle_cake": "Torta z vijolično svečo",
  "block.minecraft.purple_carpet": "Vijolična preproga",
  "block.minecraft.purple_concrete": "Vijoličen beton",
  "block.minecraft.purple_concrete_powder": "Vijoličen cement",
  "block.minecraft.purple_glazed_terracotta": "Vijolična glazirana terakota",
  "block.minecraft.purple_shulker_box": "Vijolična shulker skrinja",
  "block.minecraft.purple_stained_glass": "Vijolično obarvano steklo",
  "block.minecraft.purple_stained_glass_pane": "Vijolično obarvan vitraž",
  "block.minecraft.purple_terracotta": "Vijolična terakota",
  "block.minecraft.purple_wool": "Vijolična volna",
  "block.minecraft.purpur_block": "Purpurna kocka",
  "block.minecraft.purpur_pillar": "Purpurni steber",
  "block.minecraft.purpur_slab": "Purpurna plošča",
  "block.minecraft.purpur_stairs": "Purpurne stopnice",
  "block.minecraft.quartz_block": "Kocka nethernega kremena",
  "block.minecraft.quartz_bricks": "Kremenaste opeke",
  "block.minecraft.quartz_pillar": "Steber nethernega kremena",
  "block.minecraft.quartz_slab": "Plošča nethernega kremena",
  "block.minecraft.quartz_stairs": "Stopnice nethernega kremena",
  "block.minecraft.rail": "Tirnica",
  "block.minecraft.raw_copper_block": "Kocka surovega bakra",
  "block.minecraft.raw_gold_block": "Kocka surovega zlata",
  "block.minecraft.raw_iron_block": "Surova železna kocka",
  "block.minecraft.red_banner": "Rdeč prapor",
  "block.minecraft.red_bed": "Rdeča postelja",
  "block.minecraft.red_candle": "Rdeča sveča",
  "block.minecraft.red_candle_cake": "Torta z rdečo svečo",
  "block.minecraft.red_carpet": "Rdeča preproga",
  "block.minecraft.red_concrete": "Rdeč beton",
  "block.minecraft.red_concrete_powder": "Rdeč cement",
  "block.minecraft.red_glazed_terracotta": "Rdeča glazirana terakota",
  "block.minecraft.red_mushroom": "Golobica",
  "block.minecraft.red_mushroom_block": "Kocka golobice",
  "block.minecraft.red_nether_brick_slab": "Rdeča netherna opečnata plošča",
  "block.minecraft.red_nether_brick_stairs": "Rdeče netherne opečnate stopnice",
  "block.minecraft.red_nether_brick_wall": "Rdeči netherni opečnati zid",
  "block.minecraft.red_nether_bricks": "Rdeča netherna opeka",
  "block.minecraft.red_sand": "Rdeči pesek",
  "block.minecraft.red_sandstone": "Rdeči peščenjak",
  "block.minecraft.red_sandstone_slab": "Rdeča peščenjakova plošča",
  "block.minecraft.red_sandstone_stairs": "Rdeče peščenjakove stopnice",
  "block.minecraft.red_sandstone_wall": "Rdeči peščenjakov zid",
  "block.minecraft.red_shulker_box": "Rdeča shulker skrinja",
  "block.minecraft.red_stained_glass": "Rdeče obarvano steklo",
  "block.minecraft.red_stained_glass_pane": "Rdeče pobarvan vitraž",
  "block.minecraft.red_terracotta": "Rdeča terakota",
  "block.minecraft.red_tulip": "Rdeči tulipan",
  "block.minecraft.red_wool": "Rdeča volna",
  "block.minecraft.redstone_block": "Kocka Redstona",
  "block.minecraft.redstone_lamp": "Redstone svetilka",
  "block.minecraft.redstone_ore": "Redstone ruda",
  "block.minecraft.redstone_torch": "Redstone bakla",
  "block.minecraft.redstone_wall_torch": "Redstone bakla na steni",
  "block.minecraft.redstone_wire": "Redstone žica",
  "block.minecraft.reinforced_deepslate": "Ojačan skrilavec",
  "block.minecraft.repeater": "Redstone ojačevalec",
  "block.minecraft.repeating_command_block": "Ponavljanje ukazne kocke",
  "block.minecraft.resin_block": "Kocka smole",
  "block.minecraft.resin_brick_slab": "Plošča iz smolnih opek",
  "block.minecraft.resin_brick_stairs": "Stopnice iz smolnih opek",
  "block.minecraft.resin_brick_wall": "Zid iz smolnih opek",
  "block.minecraft.resin_bricks": "Smolnate opeke",
  "block.minecraft.resin_clump": "Kepa smole",
  "block.minecraft.respawn_anchor": "Sidro ponovnega življenja",
  "block.minecraft.rooted_dirt": "Zakoreninjena zemlja",
  "block.minecraft.rose_bush": "Grm vrtnic",
  "block.minecraft.sand": "Pesek",
  "block.minecraft.sandstone": "Peščenjak",
  "block.minecraft.sandstone_slab": "Peščenjakova plošča",
  "block.minecraft.sandstone_stairs": "Peščenjakove stopnice",
  "block.minecraft.sandstone_wall": "Peščenjakov zid",
  "block.minecraft.scaffolding": "Gradbeni oder",
  "block.minecraft.sculk": "Skulk",
  "block.minecraft.sculk_catalyst": "Skulk katalizator",
  "block.minecraft.sculk_sensor": "Sculk senzor",
  "block.minecraft.sculk_shrieker": "Skulkov vreščač",
  "block.minecraft.sculk_vein": "Žila skulka",
  "block.minecraft.sea_lantern": "Morska svetilka",
  "block.minecraft.sea_pickle": "Morska kumara",
  "block.minecraft.seagrass": "Morska trava",
  "block.minecraft.set_spawn": "Nastavljeno mesto ponovnega življenja",
  "block.minecraft.short_dry_grass": "Kratka suha trava",
  "block.minecraft.short_grass": "Kratka trava",
  "block.minecraft.shroomlight": "Gobanova luč",
  "block.minecraft.shulker_box": "Shulker skrinja",
  "block.minecraft.skeleton_skull": "Lobanja okostnjaka",
  "block.minecraft.skeleton_wall_skull": "Lobanja okostnjaka na steni",
  "block.minecraft.slime_block": "Kocka sluzi",
  "block.minecraft.small_amethyst_bud": "Majhen brst ametista",
  "block.minecraft.small_dripleaf": "Majhen kapljični list",
  "block.minecraft.smithing_table": "Orodjarjeva miza",
  "block.minecraft.smoker": "Prekajevalnik",
  "block.minecraft.smooth_basalt": "Gladek bazalt",
  "block.minecraft.smooth_quartz": "Gladka kocka kremenovega kamna",
  "block.minecraft.smooth_quartz_slab": "Plošča gladkega nethernega kremena",
  "block.minecraft.smooth_quartz_stairs": "Stopnice gladkega nethernega kremena",
  "block.minecraft.smooth_red_sandstone": "Gladek rdeči peščenjak",
  "block.minecraft.smooth_red_sandstone_slab": "Gladka rdeča peščenjakova plošča",
  "block.minecraft.smooth_red_sandstone_stairs": "Gladke rdeče peščenjakove stopnice",
  "block.minecraft.smooth_sandstone": "Gladek peščenjak",
  "block.minecraft.smooth_sandstone_slab": "Gladka peščenjakova plošča",
  "block.minecraft.smooth_sandstone_stairs": "Gladke peščenjakove stopnice",
  "block.minecraft.smooth_stone": "Kamen",
  "block.minecraft.smooth_stone_slab": "Gladka kamnita plošča",
  "block.minecraft.sniffer_egg": "Jajček z vohljačem",
  "block.minecraft.snow": "Sneg",
  "block.minecraft.snow_block": "Kocka snega",
  "block.minecraft.soul_campfire": "Taborni ogenj duš",
  "block.minecraft.soul_fire": "Ogenj duš",
  "block.minecraft.soul_lantern": "Svetila duše",
  "block.minecraft.soul_sand": "Pesek duš",
  "block.minecraft.soul_soil": "Zemlja duš",
  "block.minecraft.soul_torch": "Bakla duš",
  "block.minecraft.soul_wall_torch": "Bakla duš na steni",
  "block.minecraft.spawn.not_valid": "Nimate domače postelje, sidra ponovnega življenja ali pa sta ovirana",
  "block.minecraft.spawner": "Izvir pošasti",
  "block.minecraft.spawner.desc1": "Interakcija s pojavnim jajčkom:",
  "block.minecraft.spawner.desc2": "Nastaviti tip moba",
  "block.minecraft.sponge": "Spužva",
  "block.minecraft.spore_blossom": "Cvet spore",
  "block.minecraft.spruce_button": "Smrekov gumb",
  "block.minecraft.spruce_door": "Smrekova vrata",
  "block.minecraft.spruce_fence": "Smrekova ograja",
  "block.minecraft.spruce_fence_gate": "Smrekova ograjna vrata",
  "block.minecraft.spruce_hanging_sign": "Smrekov viseči znak",
  "block.minecraft.spruce_leaves": "Smrekovo listje",
  "block.minecraft.spruce_log": "Smrekov hlod",
  "block.minecraft.spruce_planks": "Smrekove deske",
  "block.minecraft.spruce_pressure_plate": "Smrekova zaznavna plošča",
  "block.minecraft.spruce_sapling": "Smrekova sadika",
  "block.minecraft.spruce_shelf": "Smrekova Polica",
  "block.minecraft.spruce_sign": "Smrekova tabla",
  "block.minecraft.spruce_slab": "Smrekova plošča",
  "block.minecraft.spruce_stairs": "Smrekove stopnice",
  "block.minecraft.spruce_trapdoor": "Smrekova loputa",
  "block.minecraft.spruce_wall_hanging_sign": "Smrekov stenski viseči znak",
  "block.minecraft.spruce_wall_sign": "Smrekova tabla na zidu",
  "block.minecraft.spruce_wood": "Smrekov les",
  "block.minecraft.sticky_piston": "Lepljiv bat",
  "block.minecraft.stone": "Kamen",
  "block.minecraft.stone_brick_slab": "Kamnita opečnata plošča",
  "block.minecraft.stone_brick_stairs": "Kamnite opečnate stopnice",
  "block.minecraft.stone_brick_wall": "Kamnit opečnat zid",
  "block.minecraft.stone_bricks": "Kamnite opeke",
  "block.minecraft.stone_button": "Kamnit gumb",
  "block.minecraft.stone_pressure_plate": "Kamnita zaznavna plošča",
  "block.minecraft.stone_slab": "Kamnita plošča",
  "block.minecraft.stone_stairs": "Kamnite stopnice",
  "block.minecraft.stonecutter": "Rezalnik kamna",
  "block.minecraft.stripped_acacia_log": "Olupljen akacijev hlod",
  "block.minecraft.stripped_acacia_wood": "Olupljen akacijev les",
  "block.minecraft.stripped_bamboo_block": "Olupljena kocka bambusa",
  "block.minecraft.stripped_birch_log": "Olupljen brezov hlod",
  "block.minecraft.stripped_birch_wood": "Olupljen brezov les",
  "block.minecraft.stripped_cherry_log": "Olupljen češnjev hlod",
  "block.minecraft.stripped_cherry_wood": "Olupljen češnjev les",
  "block.minecraft.stripped_crimson_hyphae": "Olupljene krvaveče hife",
  "block.minecraft.stripped_crimson_stem": "Olupljen krvaveč bet",
  "block.minecraft.stripped_dark_oak_log": "Olupljen temno hrastov hlod",
  "block.minecraft.stripped_dark_oak_wood": "Olupljen temen hrastov les",
  "block.minecraft.stripped_jungle_log": "Olupljen džungelski hlod",
  "block.minecraft.stripped_jungle_wood": "Olupljen džungelski les",
  "block.minecraft.stripped_mangrove_log": "Olupljeno mangrovo deblo",
  "block.minecraft.stripped_mangrove_wood": "Olupljen mangrov les",
  "block.minecraft.stripped_oak_log": "Olupljen hrastov hlod",
  "block.minecraft.stripped_oak_wood": "Olupljen hrastov les",
  "block.minecraft.stripped_pale_oak_log": "Olupljen bled hrastov hlod",
  "block.minecraft.stripped_pale_oak_wood": "Oluščeni bledi hrastov les",
  "block.minecraft.stripped_spruce_log": "Olupljen smrekov hlod",
  "block.minecraft.stripped_spruce_wood": "Olupljen smrekov les",
  "block.minecraft.stripped_warped_hyphae": "Olupljene popačene hife",
  "block.minecraft.stripped_warped_stem": "Olupljen popačen bet",
  "block.minecraft.structure_block": "Strukturna kocka",
  "block.minecraft.structure_void": "Strukturna praznina",
  "block.minecraft.sugar_cane": "Sladkorni trs",
  "block.minecraft.sunflower": "Sončnica",
  "block.minecraft.suspicious_gravel": "Sumljivi gramoz",
  "block.minecraft.suspicious_sand": "Sumljivi pesek",
  "block.minecraft.sweet_berry_bush": "Grmičevje sladkih jagod",
  "block.minecraft.tall_dry_grass": "Visoka suha trava",
  "block.minecraft.tall_grass": "Visoka trava",
  "block.minecraft.tall_seagrass": "Visoka morska trava",
  "block.minecraft.target": "Tarča",
  "block.minecraft.terracotta": "Terakota",
  "block.minecraft.test_block": "Testna kocka",
  "block.minecraft.test_instance_block": "Preskusna kocka instance",
  "block.minecraft.tinted_glass": "Zatemnjeno steklo",
  "block.minecraft.tnt": "Dinamit",
  "block.minecraft.tnt.disabled": "Eksplozije TNT so onemogočene",
  "block.minecraft.torch": "Bakla",
  "block.minecraft.torchflower": "Baklovka",
  "block.minecraft.torchflower_crop": "Pridelek baklovega cveta",
  "block.minecraft.trapped_chest": "Skrinja s pastjo",
  "block.minecraft.trial_spawner": "Preizkusni izvir pošasti",
  "block.minecraft.tripwire": "Žična past",
  "block.minecraft.tripwire_hook": "Kavelj žične pasti",
  "block.minecraft.tube_coral": "Cevasta korala",
  "block.minecraft.tube_coral_block": "Kocka cevaste korale",
  "block.minecraft.tube_coral_fan": "Veje cevaste korale",
  "block.minecraft.tube_coral_wall_fan": "Veje cevaste korale na steni",
  "block.minecraft.tuff": "Lehnjak",
  "block.minecraft.tuff_brick_slab": "Lehnjakove opečne stopnice",
  "block.minecraft.tuff_brick_stairs": "Lehnjakove opečne stopnice",
  "block.minecraft.tuff_brick_wall": "Lehnjakov opečni zid",
  "block.minecraft.tuff_bricks": "Lehnjakove opeke",
  "block.minecraft.tuff_slab": "Lehnjakova plošča",
  "block.minecraft.tuff_stairs": "Lehnjakove stopnice",
  "block.minecraft.tuff_wall": "Lehnjakov zid",
  "block.minecraft.turtle_egg": "Želvino jajce",
  "block.minecraft.twisting_vines": "Divje plezalke",
  "block.minecraft.twisting_vines_plant": "Prepletena ovijalka",
  "block.minecraft.vault": "Shramba",
  "block.minecraft.verdant_froglight": "Zelena žabja luč",
  "block.minecraft.vine": "Ovijalke",
  "block.minecraft.void_air": "Prazninski zrak",
  "block.minecraft.wall_torch": "Bakla na steni",
  "block.minecraft.warped_button": "Popačen gumb",
  "block.minecraft.warped_door": "Popačena vrata",
  "block.minecraft.warped_fence": "Popačena ograja",
  "block.minecraft.warped_fence_gate": "Popačena ograjna vrata",
  "block.minecraft.warped_fungus": "Popačena goba",
  "block.minecraft.warped_hanging_sign": "Popačen viseči znak",
  "block.minecraft.warped_hyphae": "Popačene hife",
  "block.minecraft.warped_nylium": "Popačen nilij",
  "block.minecraft.warped_planks": "Popačene deske",
  "block.minecraft.warped_pressure_plate": "Popačena zaznavna plošča",
  "block.minecraft.warped_roots": "Popačene korenine",
  "block.minecraft.warped_shelf": "Popačena Polica",
  "block.minecraft.warped_sign": "Popačena tabla",
  "block.minecraft.warped_slab": "Popačena plošča",
  "block.minecraft.warped_stairs": "Popačene stopnice",
  "block.minecraft.warped_stem": "Popačen bet",
  "block.minecraft.warped_trapdoor": "Popačena loputa",
  "block.minecraft.warped_wall_hanging_sign": "Popačen stenski viseči znak",
  "block.minecraft.warped_wall_sign": "Popačena tabla na zidu",
  "block.minecraft.warped_wart_block": "Kocka popačenih bradavic",
  "block.minecraft.water": "Voda",
  "block.minecraft.water_cauldron": "Kotel z vodo",
  "block.minecraft.waxed_chiseled_copper": "Povoskan izklesan baker",
  "block.minecraft.waxed_copper_bars": "Povoskane Bakrene Rešetke",
  "block.minecraft.waxed_copper_block": "Povoskana bakrena kocka",
  "block.minecraft.waxed_copper_bulb": "Povoskana bakrena žarnica",
  "block.minecraft.waxed_copper_chain": "Povoskana Bakrena Veriga",
  "block.minecraft.waxed_copper_chest": "Povoskana Bakrena Skrinja",
  "block.minecraft.waxed_copper_door": "Povoskana bakrena vrata",
  "block.minecraft.waxed_copper_golem_statue": "Povoskan Kip Bakrenega Golema",
  "block.minecraft.waxed_copper_grate": "Povoskana bakrena rešetka",
  "block.minecraft.waxed_copper_lantern": "Povoskana Bakrena Svetilka",
  "block.minecraft.waxed_copper_trapdoor": "Povoskana Bakrena Loputa",
  "block.minecraft.waxed_cut_copper": "Povoskan rezan baker",
  "block.minecraft.waxed_cut_copper_slab": "Povoskana rezana bakrena plošča",
  "block.minecraft.waxed_cut_copper_stairs": "Povoskane rezane bakrene stopnice",
  "block.minecraft.waxed_exposed_chiseled_copper": "Povoskan izpostavljen izklesan baker",
  "block.minecraft.waxed_exposed_copper": "Povoskani izpostavljeni baker",
  "block.minecraft.waxed_exposed_copper_bars": "Povoskane Izpostavljene Bakrene Rešetke",
  "block.minecraft.waxed_exposed_copper_bulb": "Povoskana izpostavljena bakrena žarnica",
  "block.minecraft.waxed_exposed_copper_chain": "Povoskana Izpostavljena Bakrena Veriga",
  "block.minecraft.waxed_exposed_copper_chest": "Povoskana Izpostavljena Bakrena Skrinja",
  "block.minecraft.waxed_exposed_copper_door": "Povoskana izpostavljena bakrena vrata",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Povoskan Izpostavljen Kip Bakrenega Golema",
  "block.minecraft.waxed_exposed_copper_grate": "Povoskana izpostavljena bakrena rešetka",
  "block.minecraft.waxed_exposed_copper_lantern": "Povoskana Izpostavljena Bakrena Svetilka",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Povoskana izpostavljena bakrena loputa",
  "block.minecraft.waxed_exposed_cut_copper": "Povoskani izpostavljen rezan baker",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Povoskana izpostavljena bakrena ploščad",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Povoskane izpostavljene rezane bakrene stopnice",
  "block.minecraft.waxed_exposed_lightning_rod": "Povoskan Izpostavljen Strelovod",
  "block.minecraft.waxed_lightning_rod": "Povoskan Strelovod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Povoskan oksidiran izklesan baker",
  "block.minecraft.waxed_oxidized_copper": "Povoskani oksidiran baker",
  "block.minecraft.waxed_oxidized_copper_bars": "Povoskane Oksidirane Bakrene Rešetke",
  "block.minecraft.waxed_oxidized_copper_bulb": "Povoskana oksidirana bakrena žarnica",
  "block.minecraft.waxed_oxidized_copper_chain": "Povoskana Oksidirana Bakrena Veriga",
  "block.minecraft.waxed_oxidized_copper_chest": "Povoskana Oksidirana Bakrena Skrinja",
  "block.minecraft.waxed_oxidized_copper_door": "Povoskana oksidirana bakrena vrata",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Povoskan Oksidiran Kip Bakrenega Golema",
  "block.minecraft.waxed_oxidized_copper_grate": "Povoskana oksidirana bakrena rešetka",
  "block.minecraft.waxed_oxidized_copper_lantern": "Povoskana Oksidirana Bakrena Svetilka",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Povoskana oksidirana bakrena loputa",
  "block.minecraft.waxed_oxidized_cut_copper": "Povoskani oksidirani rezan baker",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Povoskana oksidirana rezana bakrena ploščad",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Povoskane oksidirane rezane bakrene stopnice",
  "block.minecraft.waxed_oxidized_lightning_rod": "Povoskan Oksidiran Strelovod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Povoskani prepereli izklesan baker",
  "block.minecraft.waxed_weathered_copper": "Povoskani prepereli baker",
  "block.minecraft.waxed_weathered_copper_bars": "Povoskane Preperele Bakrene Rešetke",
  "block.minecraft.waxed_weathered_copper_bulb": "Povoskana vremensko pogojena bakrena žarnica",
  "block.minecraft.waxed_weathered_copper_chain": "Povoskana Preperela Bakrena Veriga",
  "block.minecraft.waxed_weathered_copper_chest": "Povoskana Preperela Bakrena Skrinja",
  "block.minecraft.waxed_weathered_copper_door": "Povoskana vremensko pogojena bakrena vrata",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Povoskan Preperel Kip Bakrenega Golema",
  "block.minecraft.waxed_weathered_copper_grate": "Povoskana vremensko pogojena bakrena rešetka",
  "block.minecraft.waxed_weathered_copper_lantern": "Povoskana Preperela Bakrena Svetilka",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Povoskana vremensko pogojena bakrena akacijeva loputa",
  "block.minecraft.waxed_weathered_cut_copper": "Povoskani prepereli rezan baker",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Povoskana preperela rezana bakrena ploščad",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Povoskane preperele rezane bakrene stopnice",
  "block.minecraft.waxed_weathered_lightning_rod": "Povoskan Preperel Strelovod",
  "block.minecraft.weathered_chiseled_copper": "Prepereli izklesan baker",
  "block.minecraft.weathered_copper": "Preperel baker",
  "block.minecraft.weathered_copper_bars": "Preperele Bakrene Rešetke",
  "block.minecraft.weathered_copper_bulb": "Vremensko pogojena bakrena žarnica",
  "block.minecraft.weathered_copper_chain": "Preperela Bakrena Veriga",
  "block.minecraft.weathered_copper_chest": "Preperela Bakrena Skrinja",
  "block.minecraft.weathered_copper_door": "Vremensko pogojena bakrena vrata",
  "block.minecraft.weathered_copper_golem_statue": "Preperel Kip Bakrenega Golema",
  "block.minecraft.weathered_copper_grate": "Vremensko pogojena bakrena rešetka",
  "block.minecraft.weathered_copper_lantern": "Preperela Bakrena Svetilka",
  "block.minecraft.weathered_copper_trapdoor": "Vremensko pogojena bakrena akacijeva loputa",
  "block.minecraft.weathered_cut_copper": "Preperel rezan baker",
  "block.minecraft.weathered_cut_copper_slab": "Preperela rezana bakrena plošča",
  "block.minecraft.weathered_cut_copper_stairs": "Preperele rezane bakrene stopnice",
  "block.minecraft.weathered_lightning_rod": "Preperel Strelovod",
  "block.minecraft.weeping_vines": "Javkajoče ovijalke",
  "block.minecraft.weeping_vines_plant": "Jokajoča plezalka",
  "block.minecraft.wet_sponge": "Mokra spužva",
  "block.minecraft.wheat": "Pšenica",
  "block.minecraft.white_banner": "Bel prapor",
  "block.minecraft.white_bed": "Bela postelja",
  "block.minecraft.white_candle": "Bela sveča",
  "block.minecraft.white_candle_cake": "Torta z belo svečo",
  "block.minecraft.white_carpet": "Bela preproga",
  "block.minecraft.white_concrete": "Bel beton",
  "block.minecraft.white_concrete_powder": "Bel cement",
  "block.minecraft.white_glazed_terracotta": "Bela glazirana terakota",
  "block.minecraft.white_shulker_box": "Bela shulker skrinja",
  "block.minecraft.white_stained_glass": "Belo obarvano steklo",
  "block.minecraft.white_stained_glass_pane": "Belo obarvan vitraž",
  "block.minecraft.white_terracotta": "Bela terakota",
  "block.minecraft.white_tulip": "Beli tulipan",
  "block.minecraft.white_wool": "Bela volna",
  "block.minecraft.wildflowers": "Divje rože",
  "block.minecraft.wither_rose": "Wither vrtnica",
  "block.minecraft.wither_skeleton_skull": "Lobanja wither okostnjaka",
  "block.minecraft.wither_skeleton_wall_skull": "Lobanja wither okostnjaka na steni",
  "block.minecraft.yellow_banner": "Rumen prapor",
  "block.minecraft.yellow_bed": "Rumena postelja",
  "block.minecraft.yellow_candle": "Rumena sveča",
  "block.minecraft.yellow_candle_cake": "Torta z rumeno svečo",
  "block.minecraft.yellow_carpet": "Rumena preproga",
  "block.minecraft.yellow_concrete": "Rumen beton",
  "block.minecraft.yellow_concrete_powder": "Rumen cement",
  "block.minecraft.yellow_glazed_terracotta": "Rumena glazirana terakota",
  "block.minecraft.yellow_shulker_box": "Rumena shulker skrinja",
  "block.minecraft.yellow_stained_glass": "Rumeno obarvano steklo",
  "block.minecraft.yellow_stained_glass_pane": "Rumeno obarvan vitraž",
  "block.minecraft.yellow_terracotta": "Rumena terakota",
  "block.minecraft.yellow_wool": "Rumena volna",
  "block.minecraft.zombie_head": "Zombijeva glava",
  "block.minecraft.zombie_wall_head": "Zombijeva glava na steni",
  "item.minecraft.acacia_boat": "Akacijev čoln",
  "item.minecraft.acacia_chest_boat": "Akacijev čoln s skrinjo",
  "item.minecraft.allay_spawn_egg": "Jajček z Allayem",
  "item.minecraft.amethyst_shard": "Amatistev zdrob",
  "item.minecraft.angler_pottery_shard": "Lončen drobec ribiča",
  "item.minecraft.angler_pottery_sherd": "Lončen drobec ribiča",
  "item.minecraft.apple": "Jabolko",
  "item.minecraft.archer_pottery_shard": "Lončen drobec strelca",
  "item.minecraft.archer_pottery_sherd": "Lončen drobec lokostrelca",
  "item.minecraft.armadillo_scute": "Pasavčev ščit",
  "item.minecraft.armadillo_spawn_egg": "Jajček s pasavcem",
  "item.minecraft.armor_stand": "Stojalo za oklep",
  "item.minecraft.arms_up_pottery_shard": "Lončen drobec rok v zrak",
  "item.minecraft.arms_up_pottery_sherd": "Lončen drobec rok v zrak",
  "item.minecraft.arrow": "Puščica",
  "item.minecraft.axolotl_bucket": "Vedro z aksolotlom",
  "item.minecraft.axolotl_spawn_egg": "Jajček z aksolotlom",
  "item.minecraft.baked_potato": "Pečen krompir",
  "item.minecraft.bamboo_chest_raft": "Bambusov splav s skrinjo",
  "item.minecraft.bamboo_raft": "Bambusov splav",
  "item.minecraft.bat_spawn_egg": "Jajček z netopirjem",
  "item.minecraft.bee_spawn_egg": "Jajček s čebelo",
  "item.minecraft.beef": "Surova govedina",
  "item.minecraft.beetroot": "Rdeča pesa",
  "item.minecraft.beetroot_seeds": "Pesina semena",
  "item.minecraft.beetroot_soup": "Pesina juha",
  "item.minecraft.birch_boat": "Brezov čoln",
  "item.minecraft.birch_chest_boat": "Brezov čoln s skrinjo",
  "item.minecraft.black_bundle": "Črna vreča",
  "item.minecraft.black_dye": "Črno barvilo",
  "item.minecraft.black_harness": "Črna oprsnica",
  "item.minecraft.blade_pottery_shard": "Lončen drobec rezila",
  "item.minecraft.blade_pottery_sherd": "Lončen drobec rezila",
  "item.minecraft.blaze_powder": "Blaze prah",
  "item.minecraft.blaze_rod": "Blaze palica",
  "item.minecraft.blaze_spawn_egg": "Jajček z blazom",
  "item.minecraft.blue_bundle": "Modra vreča",
  "item.minecraft.blue_dye": "Modro barvilo",
  "item.minecraft.blue_egg": "Modro jajce",
  "item.minecraft.blue_harness": "Modra oprsnica",
  "item.minecraft.bogged_spawn_egg": "Jajček s smrkavcem",
  "item.minecraft.bolt_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Zaklepna oklepna obloga",
  "item.minecraft.bone": "Kost",
  "item.minecraft.bone_meal": "Kostna moka",
  "item.minecraft.book": "Knjiga",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure zamaknjen vzorec pasice",
  "item.minecraft.bow": "Lok",
  "item.minecraft.bowl": "Skleda",
  "item.minecraft.bread": "Kruh",
  "item.minecraft.breeze_rod": "Vetrična palica",
  "item.minecraft.breeze_spawn_egg": "Jajček z Vetričem",
  "item.minecraft.brewer_pottery_shard": "Lončen drobec varilca",
  "item.minecraft.brewer_pottery_sherd": "Lončen drobec varilca",
  "item.minecraft.brewing_stand": "Stojalo za napoje",
  "item.minecraft.brick": "Opeka",
  "item.minecraft.brown_bundle": "Rjava vreča",
  "item.minecraft.brown_dye": "Rjavo barvilo",
  "item.minecraft.brown_egg": "Rjavo jajce",
  "item.minecraft.brown_harness": "Rjava oprsnica",
  "item.minecraft.brush": "Krtača",
  "item.minecraft.bucket": "Vedro",
  "item.minecraft.bundle": "Vreča",
  "item.minecraft.bundle.empty": "Prazno",
  "item.minecraft.bundle.empty.description": "Lahko drži mešan kup predmetov",
  "item.minecraft.bundle.full": "Polno",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Lončen drobec ognja",
  "item.minecraft.burn_pottery_sherd": "Lončen drobec ognja",
  "item.minecraft.camel_husk_spawn_egg": "Jajček s posušeno kamelo",
  "item.minecraft.camel_spawn_egg": "Jajček s kamelo",
  "item.minecraft.carrot": "Korenje",
  "item.minecraft.carrot_on_a_stick": "Korenje na palici",
  "item.minecraft.cat_spawn_egg": "Jajček z mačko",
  "item.minecraft.cauldron": "Kotel",
  "item.minecraft.cave_spider_spawn_egg": "Jajček z jamskim pajkom",
  "item.minecraft.chainmail_boots": "Verižni čevlji",
  "item.minecraft.chainmail_chestplate": "Verižni prsni oklep",
  "item.minecraft.chainmail_helmet": "Verižna čelada",
  "item.minecraft.chainmail_leggings": "Verižne hlače",
  "item.minecraft.charcoal": "Oglje",
  "item.minecraft.cherry_boat": "Češnjev čoln",
  "item.minecraft.cherry_chest_boat": "Češnjev čoln s skrinjo",
  "item.minecraft.chest_minecart": "Voziček s skrinjo",
  "item.minecraft.chicken": "Surov piščanec",
  "item.minecraft.chicken_spawn_egg": "Jajček s kokošjo",
  "item.minecraft.chorus_fruit": "Refrensko sadje",
  "item.minecraft.clay_ball": "Glinena krogla",
  "item.minecraft.clock": "Ura",
  "item.minecraft.coal": "Premog",
  "item.minecraft.coast_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Obroba oklepa",
  "item.minecraft.cocoa_beans": "Kakavova zrna",
  "item.minecraft.cod": "Surova trska",
  "item.minecraft.cod_bucket": "Vedro s trsko",
  "item.minecraft.cod_spawn_egg": "Jajček s trsko",
  "item.minecraft.command_block_minecart": "Voziček z ukazno kocko",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Goveji zrezek",
  "item.minecraft.cooked_chicken": "Pečen piščanec",
  "item.minecraft.cooked_cod": "Kuhana trska",
  "item.minecraft.cooked_mutton": "Pečena jagnjetina",
  "item.minecraft.cooked_porkchop": "Svinjski zrezek",
  "item.minecraft.cooked_rabbit": "Pečen zajec",
  "item.minecraft.cooked_salmon": "Pečen losos",
  "item.minecraft.cookie": "Piškot",
  "item.minecraft.copper_axe": "Bakrena Sekira",
  "item.minecraft.copper_boots": "Bakreni Čevlji",
  "item.minecraft.copper_chestplate": "Bakren prsni oklep",
  "item.minecraft.copper_golem_spawn_egg": "Jajček z Bakrenim Golemom",
  "item.minecraft.copper_helmet": "Bakrena Čelada",
  "item.minecraft.copper_hoe": "Bakrena Motika",
  "item.minecraft.copper_horse_armor": "Bakren konjski oklep",
  "item.minecraft.copper_ingot": "Bakrena palica",
  "item.minecraft.copper_leggings": "Bakrene Hlače",
  "item.minecraft.copper_nautilus_armor": "Bakren Oklep Amonita",
  "item.minecraft.copper_nugget": "Bakreno Zrno",
  "item.minecraft.copper_pickaxe": "Bakren Kramp",
  "item.minecraft.copper_shovel": "Bakrena Lopata",
  "item.minecraft.copper_spear": "Bakrena Kopija",
  "item.minecraft.copper_sword": "Bakren Meč",
  "item.minecraft.cow_spawn_egg": "Jajček s kravo",
  "item.minecraft.creaking_spawn_egg": "Jajček s creakingom",
  "item.minecraft.creeper_banner_pattern": "Vzorec za zastave",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Vzorec pasice Creeper Charge",
  "item.minecraft.creeper_spawn_egg": "Jajček s creeperjem",
  "item.minecraft.crossbow": "Samostrel",
  "item.minecraft.crossbow.projectile": "Izstrelek:",
  "item.minecraft.crossbow.projectile.multiple": "Projektile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projektile: %s",
  "item.minecraft.cyan_bundle": "Turkizna vreča",
  "item.minecraft.cyan_dye": "Turkizno barvilo",
  "item.minecraft.cyan_harness": "Cian oprsnica",
  "item.minecraft.danger_pottery_shard": "Lončen drobec nevarnosti",
  "item.minecraft.danger_pottery_sherd": "Lončen drobec nevarnosti",
  "item.minecraft.dark_oak_boat": "Temen hrastov čoln",
  "item.minecraft.dark_oak_chest_boat": "Čoln iz temnega hrasta s skrinjo",
  "item.minecraft.debug_stick": "Razvijalčeva palica",
  "item.minecraft.debug_stick.empty": "%s nima lastnosti",
  "item.minecraft.debug_stick.select": "lastnost %s ima vrednost %s",
  "item.minecraft.debug_stick.update": "\"%s\" na %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamantna sekira",
  "item.minecraft.diamond_boots": "Diamantni čevlji",
  "item.minecraft.diamond_chestplate": "Diamantni prsni oklep",
  "item.minecraft.diamond_helmet": "Diamantna čelada",
  "item.minecraft.diamond_hoe": "Diamantna motika",
  "item.minecraft.diamond_horse_armor": "Diamanten konjski oklep",
  "item.minecraft.diamond_leggings": "Diamantne hlače",
  "item.minecraft.diamond_nautilus_armor": "Diamanten oklep Nautilisa",
  "item.minecraft.diamond_pickaxe": "Diamanten kramp",
  "item.minecraft.diamond_shovel": "Diamantna lopata",
  "item.minecraft.diamond_spear": "Diamantna Kopija",
  "item.minecraft.diamond_sword": "Diamantni meč",
  "item.minecraft.disc_fragment_5": "Fragment diska",
  "item.minecraft.disc_fragment_5.desc": "Glasbeni disk - 5",
  "item.minecraft.dolphin_spawn_egg": "Jajček z delfinom",
  "item.minecraft.donkey_spawn_egg": "Jajček z oslom",
  "item.minecraft.dragon_breath": "Zmajev dih",
  "item.minecraft.dried_kelp": "Posušena alga",
  "item.minecraft.drowned_spawn_egg": "Jajček z utopljenim",
  "item.minecraft.dune_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Obloga Dune Armor",
  "item.minecraft.echo_shard": "Odmevni kristal",
  "item.minecraft.egg": "Jajce",
  "item.minecraft.elder_guardian_spawn_egg": "Jajček z nadvaruhom",
  "item.minecraft.elytra": "Elitra",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Začarana knjiga",
  "item.minecraft.enchanted_golden_apple": "Začarano zlato jabolko",
  "item.minecraft.end_crystal": "End kristal",
  "item.minecraft.ender_dragon_spawn_egg": "Jajček z Ender zmajem",
  "item.minecraft.ender_eye": "Enderjevo oko",
  "item.minecraft.ender_pearl": "Enderov biser",
  "item.minecraft.enderman_spawn_egg": "Jajček z endermanom",
  "item.minecraft.endermite_spawn_egg": "Jajček z endermitom",
  "item.minecraft.evoker_spawn_egg": "Jajček s čarodejem",
  "item.minecraft.experience_bottle": "Steklenica čarovnije",
  "item.minecraft.explorer_pottery_shard": "Lončen drobec raziskovalca",
  "item.minecraft.explorer_pottery_sherd": "Lončen drobec raziskovalca",
  "item.minecraft.eye_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Oklep za oči",
  "item.minecraft.feather": "Pero",
  "item.minecraft.fermented_spider_eye": "Fermentirano pajkovo oko",
  "item.minecraft.field_masoned_banner_pattern": "Vzorec pasice, zidane na terenu",
  "item.minecraft.filled_map": "Zemljevid",
  "item.minecraft.fire_charge": "Ognjeni naboj",
  "item.minecraft.firework_rocket": "Raketa",
  "item.minecraft.firework_rocket.flight": "Čas leta:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Zvezda ognjemeta",
  "item.minecraft.firework_star.black": "Črn",
  "item.minecraft.firework_star.blue": "Moder",
  "item.minecraft.firework_star.brown": "Rjav",
  "item.minecraft.firework_star.custom_color": "Po meri",
  "item.minecraft.firework_star.cyan": "Turkizno",
  "item.minecraft.firework_star.fade_to": "Pojemaj v ",
  "item.minecraft.firework_star.flicker": "Svetlikanje",
  "item.minecraft.firework_star.gray": "Siv",
  "item.minecraft.firework_star.green": "Zelen",
  "item.minecraft.firework_star.light_blue": "Svetlo moder",
  "item.minecraft.firework_star.light_gray": "Svetlo siv",
  "item.minecraft.firework_star.lime": "Svetlo zelen",
  "item.minecraft.firework_star.magenta": "Škrlaten",
  "item.minecraft.firework_star.orange": "Oranžen",
  "item.minecraft.firework_star.pink": "Roza",
  "item.minecraft.firework_star.purple": "Vijoličen",
  "item.minecraft.firework_star.red": "Rdeč",
  "item.minecraft.firework_star.shape": "Neznana oblika",
  "item.minecraft.firework_star.shape.burst": "Eksplozija",
  "item.minecraft.firework_star.shape.creeper": "Oblika creeperja",
  "item.minecraft.firework_star.shape.large_ball": "Velika krogla",
  "item.minecraft.firework_star.shape.small_ball": "Mala krogla",
  "item.minecraft.firework_star.shape.star": "Oblika zvezde",
  "item.minecraft.firework_star.trail": "Sled",
  "item.minecraft.firework_star.white": "Bel",
  "item.minecraft.firework_star.yellow": "Rumen",
  "item.minecraft.fishing_rod": "Ribiška palica",
  "item.minecraft.flint": "Kremen",
  "item.minecraft.flint_and_steel": "Netilo",
  "item.minecraft.flow_armor_trim_smithing_template": "Kovaška predloga",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Vzorec zastave",
  "item.minecraft.flow_banner_pattern.desc": "Tok",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Lončen drobec tok",
  "item.minecraft.flower_banner_pattern": "Vzorec za zastave",
  "item.minecraft.flower_banner_pattern.desc": "Roža",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Cvetlični lonček",
  "item.minecraft.fox_spawn_egg": "Jajček z lisico",
  "item.minecraft.friend_pottery_shard": "Lončen drobec prijatelja",
  "item.minecraft.friend_pottery_sherd": "Lončen drobec prijatelja",
  "item.minecraft.frog_spawn_egg": "Jajček z žabo",
  "item.minecraft.furnace_minecart": "Voziček s pečjo",
  "item.minecraft.ghast_spawn_egg": "Jajček z ghastom",
  "item.minecraft.ghast_tear": "Ghastova solza",
  "item.minecraft.glass_bottle": "Steklenica",
  "item.minecraft.glistering_melon_slice": "Lesketajoča rezina lubenice",
  "item.minecraft.globe_banner_pattern": "Vzorec za zastave",
  "item.minecraft.globe_banner_pattern.desc": "Globus",
  "item.minecraft.globe_banner_pattern.new": "Vzorec pasice globus",
  "item.minecraft.glow_berries": "Žareče jagode",
  "item.minecraft.glow_ink_sac": "Svetleča tinta",
  "item.minecraft.glow_item_frame": "Svetleči okvir za predmet",
  "item.minecraft.glow_squid_spawn_egg": "Jajček s svetlečim lignjem",
  "item.minecraft.glowstone_dust": "Prah svetlečega kamna",
  "item.minecraft.goat_horn": "Kozji rog",
  "item.minecraft.goat_spawn_egg": "Jajček s kozo",
  "item.minecraft.gold_ingot": "Zlata palica",
  "item.minecraft.gold_nugget": "Zlato zrno",
  "item.minecraft.golden_apple": "Zlato jabolko",
  "item.minecraft.golden_axe": "Zlata sekira",
  "item.minecraft.golden_boots": "Zlati čevlji",
  "item.minecraft.golden_carrot": "Zlato korenje",
  "item.minecraft.golden_chestplate": "Zlat prsni oklep",
  "item.minecraft.golden_helmet": "Zlata čelada",
  "item.minecraft.golden_hoe": "Zlata motika",
  "item.minecraft.golden_horse_armor": "Zlat konjski oklep",
  "item.minecraft.golden_leggings": "Zlate hlače",
  "item.minecraft.golden_nautilus_armor": "Zlat oklep Nautilisa",
  "item.minecraft.golden_pickaxe": "Zlati kramp",
  "item.minecraft.golden_shovel": "Zlata lopata",
  "item.minecraft.golden_spear": "Zlata Kopija",
  "item.minecraft.golden_sword": "Zlati meč",
  "item.minecraft.gray_bundle": "Siva vreča",
  "item.minecraft.gray_dye": "Sivo barvilo",
  "item.minecraft.gray_harness": "Siva oprsnica",
  "item.minecraft.green_bundle": "Zelena vreča",
  "item.minecraft.green_dye": "Zeleno barvilo",
  "item.minecraft.green_harness": "Zelena oprsnica",
  "item.minecraft.guardian_spawn_egg": "Jajček z varuhom",
  "item.minecraft.gunpowder": "Smodnik",
  "item.minecraft.guster_banner_pattern": "Vzorec zastave",
  "item.minecraft.guster_banner_pattern.desc": "Vrtinec",
  "item.minecraft.guster_banner_pattern.new": "Vzorec pasice Guster",
  "item.minecraft.guster_pottery_sherd": "Lončen drobec zavetja",
  "item.minecraft.happy_ghast_spawn_egg": "Jajček z veselim Ghastom",
  "item.minecraft.harness": "Oprsnica",
  "item.minecraft.heart_of_the_sea": "Srce morja",
  "item.minecraft.heart_pottery_shard": "Lončen drobec srca",
  "item.minecraft.heart_pottery_sherd": "Lončen drobec srca",
  "item.minecraft.heartbreak_pottery_shard": "Lončen drobec prelomljenega srca",
  "item.minecraft.heartbreak_pottery_sherd": "Lončen drobec prelomljenega srca",
  "item.minecraft.hoglin_spawn_egg": "Jajček s svinjoglavcem",
  "item.minecraft.honey_bottle": "Steklenica medu",
  "item.minecraft.honeycomb": "Satje",
  "item.minecraft.hopper_minecart": "Voziček z lijakom",
  "item.minecraft.horse_spawn_egg": "Jajček s konjem",
  "item.minecraft.host_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Lončen drobec laježa",
  "item.minecraft.howl_pottery_sherd": "Lončen drobec laježa",
  "item.minecraft.husk_spawn_egg": "Jajček s huskom",
  "item.minecraft.ink_sac": "Tinta",
  "item.minecraft.iron_axe": "Železna sekira",
  "item.minecraft.iron_boots": "Železni čevlji",
  "item.minecraft.iron_chestplate": "Železni prsni oklep",
  "item.minecraft.iron_golem_spawn_egg": "Jajček z železnim golemom",
  "item.minecraft.iron_helmet": "Železna čelada",
  "item.minecraft.iron_hoe": "Železna motika",
  "item.minecraft.iron_horse_armor": "Železen konjski oklep",
  "item.minecraft.iron_ingot": "Železna palica",
  "item.minecraft.iron_leggings": "Železne hlače",
  "item.minecraft.iron_nautilus_armor": "Železen Oklep Nautilisa",
  "item.minecraft.iron_nugget": "Železno zrno",
  "item.minecraft.iron_pickaxe": "Železen kramp",
  "item.minecraft.iron_shovel": "Železna lopata",
  "item.minecraft.iron_spear": "Železna Kopija",
  "item.minecraft.iron_sword": "Železen meč",
  "item.minecraft.item_frame": "Okvir",
  "item.minecraft.jungle_boat": "Džungelski čoln",
  "item.minecraft.jungle_chest_boat": "Čoln v džungli s skrinjo",
  "item.minecraft.knowledge_book": "Knjiga znanja",
  "item.minecraft.lapis_lazuli": "Lazurni kamen",
  "item.minecraft.lava_bucket": "Vedro lave",
  "item.minecraft.lead": "Povodec",
  "item.minecraft.leather": "Usnje",
  "item.minecraft.leather_boots": "Usnjeni čevlji",
  "item.minecraft.leather_chestplate": "Usnjena tunika",
  "item.minecraft.leather_helmet": "Usnjena kapa",
  "item.minecraft.leather_horse_armor": "Usnjen konjski oklep",
  "item.minecraft.leather_leggings": "Usnjene hlače",
  "item.minecraft.light_blue_bundle": "Svetlo modra vreča",
  "item.minecraft.light_blue_dye": "Svetlo modro barvilo",
  "item.minecraft.light_blue_harness": "Svetlo modra oprsnica",
  "item.minecraft.light_gray_bundle": "Svetlo siva vreča",
  "item.minecraft.light_gray_dye": "Svetlo sivo barvilo",
  "item.minecraft.light_gray_harness": "Svetlo Siv Jermen",
  "item.minecraft.lime_bundle": "Svetlo zelena vreča",
  "item.minecraft.lime_dye": "Svetlo zeleno barvilo",
  "item.minecraft.lime_harness": "Svetlo zelena oprsnica",
  "item.minecraft.lingering_potion": "Dolgotrajen napoj",
  "item.minecraft.lingering_potion.effect.awkward": "Dolgotrajen osnoven napoj",
  "item.minecraft.lingering_potion.effect.empty": "Neustvarljiv dolgotrajen napoj",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Dolgotrajen napoj odpornosti proti ognju",
  "item.minecraft.lingering_potion.effect.harming": "Dolgotrajen napoj škodovanja",
  "item.minecraft.lingering_potion.effect.healing": "Dolgotrajen napoj zdravljenja",
  "item.minecraft.lingering_potion.effect.infested": "Dolgotrajen napoj okuženja",
  "item.minecraft.lingering_potion.effect.invisibility": "Dolgotrajen napoj nevidnosti",
  "item.minecraft.lingering_potion.effect.leaping": "Dolgotrajen napoj skakanja",
  "item.minecraft.lingering_potion.effect.levitation": "Dolgotrajen napoj lebdenjenja",
  "item.minecraft.lingering_potion.effect.luck": "Dolgotrajen napoj sreče",
  "item.minecraft.lingering_potion.effect.mundane": "Preprost dolgotrajen napoj",
  "item.minecraft.lingering_potion.effect.night_vision": "Dolgotrajen napoj nočnega vida",
  "item.minecraft.lingering_potion.effect.oozing": "Dolgotrajen napoj iztekanja",
  "item.minecraft.lingering_potion.effect.poison": "Dolgotrajna strupena puščica",
  "item.minecraft.lingering_potion.effect.regeneration": "Dolgotrajen napoj regeneracije",
  "item.minecraft.lingering_potion.effect.slow_falling": "Dolgotrajen napoj počasnega padanja",
  "item.minecraft.lingering_potion.effect.slowness": "Dolgotrajen napoj počastnosti",
  "item.minecraft.lingering_potion.effect.strength": "Dolgotrajen napoj moči",
  "item.minecraft.lingering_potion.effect.swiftness": "Dolgotrajen napoj hitrosti",
  "item.minecraft.lingering_potion.effect.thick": "Gost dolgotrajen napoj",
  "item.minecraft.lingering_potion.effect.turtle_master": "Dolgotrajen napoj mojstra želv",
  "item.minecraft.lingering_potion.effect.water": "Dolgotrajna steklenica vode",
  "item.minecraft.lingering_potion.effect.water_breathing": "Dolgotrajen napoj podvodnega dihanja",
  "item.minecraft.lingering_potion.effect.weakness": "Dolgotrajen napoj šibkosti",
  "item.minecraft.lingering_potion.effect.weaving": "Dolgotrajen napoj pletenja",
  "item.minecraft.lingering_potion.effect.wind_charged": "Dolgotrajen napoj vetrovne nabitosti",
  "item.minecraft.llama_spawn_egg": "Jajček z lamo",
  "item.minecraft.lodestone_compass": "Kompas iz Magnetita",
  "item.minecraft.mace": "Macola",
  "item.minecraft.magenta_bundle": "Škrlatna vreča",
  "item.minecraft.magenta_dye": "Škrlatno barvilo",
  "item.minecraft.magenta_harness": "Škrlatna oprsnica",
  "item.minecraft.magma_cream": "Krema iz magme",
  "item.minecraft.magma_cube_spawn_egg": "Jajček s kocko magme",
  "item.minecraft.mangrove_boat": "Mangrovin čoln",
  "item.minecraft.mangrove_chest_boat": "Mangrovin čoln s skrinjo",
  "item.minecraft.map": "Prazen zemljevid",
  "item.minecraft.melon_seeds": "Semena lubenice",
  "item.minecraft.melon_slice": "Rezina lubenice",
  "item.minecraft.milk_bucket": "Vedro mleka",
  "item.minecraft.minecart": "Voziček",
  "item.minecraft.miner_pottery_shard": "Lončen drobec rudarja",
  "item.minecraft.miner_pottery_sherd": "Lončen drobec rudarja",
  "item.minecraft.mojang_banner_pattern": "Vzorec za zastave",
  "item.minecraft.mojang_banner_pattern.desc": "Stvar",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Jajček z mooshroomom",
  "item.minecraft.mourner_pottery_shard": "Lončen drobec žalovalca",
  "item.minecraft.mourner_pottery_sherd": "Lončen drobec žalovalca",
  "item.minecraft.mule_spawn_egg": "Jajček z mulo",
  "item.minecraft.mushroom_stew": "Gobova juha",
  "item.minecraft.music_disc_11": "Glasbeni disk",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Glasbena plošča",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Glasbeni disk",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Glasbeni disk",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Glasbeni disk",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Glasbeni disk",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Glasbeni disk",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Glasbeni disk",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (glasbena skrinjica)",
  "item.minecraft.music_disc_far": "Glasbeni disk",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Glasbeni disk",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Glasbeni disk",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Glasbeni disk",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Glasbeni disk",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - druga stran",
  "item.minecraft.music_disc_pigstep": "Glasbeni disk",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Glasbeni disk",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Glasbeni disk",
  "item.minecraft.music_disc_relic.desc": "Aron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Glasbeni disk",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Glasbeni disk",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Glasbeni disk",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Glasbeni disk",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Glasbeni disk",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Surova jagnjetina",
  "item.minecraft.name_tag": "Imenska značka",
  "item.minecraft.nautilus_shell": "Drobnikova lupina",
  "item.minecraft.nautilus_spawn_egg": "Jajček z Nautilisom",
  "item.minecraft.nether_brick": "Netherna opeka",
  "item.minecraft.nether_star": "Netherna zvezda",
  "item.minecraft.nether_wart": "Netherna bradavica",
  "item.minecraft.netherite_axe": "Netheritna sekira",
  "item.minecraft.netherite_boots": "Netheritni čevlji",
  "item.minecraft.netherite_chestplate": "Netheritni prsni oklep",
  "item.minecraft.netherite_helmet": "Netheritna čelada",
  "item.minecraft.netherite_hoe": "Netheritna motika",
  "item.minecraft.netherite_horse_armor": "Netheritni konjski oklep",
  "item.minecraft.netherite_ingot": "Netheritna palica",
  "item.minecraft.netherite_leggings": "Netheritne hlače",
  "item.minecraft.netherite_nautilus_armor": "Netheritni oklep Nautilisa",
  "item.minecraft.netherite_pickaxe": "Netheritni kramp",
  "item.minecraft.netherite_scrap": "Košček netherita",
  "item.minecraft.netherite_shovel": "Netheritna lopata",
  "item.minecraft.netherite_spear": "Netheritna kopija",
  "item.minecraft.netherite_sword": "Netheritni meč",
  "item.minecraft.netherite_upgrade_smithing_template": "Kovačeva predloga",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheritna nadgradnja",
  "item.minecraft.oak_boat": "Hrastov čoln",
  "item.minecraft.oak_chest_boat": "Hrastov čoln s skrinjo",
  "item.minecraft.ocelot_spawn_egg": "Jajček z divjo mačko",
  "item.minecraft.ominous_bottle": "Zlovešča steklenica",
  "item.minecraft.ominous_trial_key": "Zlovešči preizkusni ključ",
  "item.minecraft.orange_bundle": "Oranžna vreča",
  "item.minecraft.orange_dye": "Oranžno barvilo",
  "item.minecraft.orange_harness": "Oranžna oprsnica",
  "item.minecraft.painting": "Slika",
  "item.minecraft.pale_oak_boat": "Čoln iz svetlega hrasta",
  "item.minecraft.pale_oak_chest_boat": "Čoln iz svetlega hrasta s skrinjo",
  "item.minecraft.panda_spawn_egg": "Jajček s pando",
  "item.minecraft.paper": "Papir",
  "item.minecraft.parched_spawn_egg": "Jajček s Parchedom",
  "item.minecraft.parrot_spawn_egg": "Jajček s papigo",
  "item.minecraft.phantom_membrane": "Fantomova membrana",
  "item.minecraft.phantom_spawn_egg": "Jajček s fantomom",
  "item.minecraft.pig_spawn_egg": "Jajček s prašičem",
  "item.minecraft.piglin_banner_pattern": "Vzorec za zastave",
  "item.minecraft.piglin_banner_pattern.desc": "Rilec",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Jajček s krutim piglinom",
  "item.minecraft.piglin_spawn_egg": "Jajček s piglinom",
  "item.minecraft.pillager_spawn_egg": "Jajček z razbojnikom",
  "item.minecraft.pink_bundle": "Rožnata vreča",
  "item.minecraft.pink_dye": "Roza barvilo",
  "item.minecraft.pink_harness": "Roza oprsnica",
  "item.minecraft.pitcher_plant": "Vrčnica",
  "item.minecraft.pitcher_pod": "Včnično seme",
  "item.minecraft.plenty_pottery_shard": "Lončen drobec obilja",
  "item.minecraft.plenty_pottery_sherd": "Lončen drobec obilja",
  "item.minecraft.poisonous_potato": "Strupen krompir",
  "item.minecraft.polar_bear_spawn_egg": "Jajček s polarnim medvedom",
  "item.minecraft.popped_chorus_fruit": "Izstreljeno refrensko sadje",
  "item.minecraft.porkchop": "Surova svinjina",
  "item.minecraft.potato": "Krompir",
  "item.minecraft.potion": "Napoj",
  "item.minecraft.potion.effect.awkward": "Osnovni napoj",
  "item.minecraft.potion.effect.empty": "Neustvarljiv napoj",
  "item.minecraft.potion.effect.fire_resistance": "Napoj odpornosti proti ognju",
  "item.minecraft.potion.effect.harming": "Napoj škodovanja",
  "item.minecraft.potion.effect.healing": "Napoj zdravljenja",
  "item.minecraft.potion.effect.infested": "Napoj okuženja",
  "item.minecraft.potion.effect.invisibility": "Napoj nevidnosti",
  "item.minecraft.potion.effect.leaping": "Napoj skakanja",
  "item.minecraft.potion.effect.levitation": "Napoj lebdenja",
  "item.minecraft.potion.effect.luck": "Napoj sreče",
  "item.minecraft.potion.effect.mundane": "Preprosti napoj",
  "item.minecraft.potion.effect.night_vision": "Napoj nočnega vida",
  "item.minecraft.potion.effect.oozing": "Napoj iztekanja",
  "item.minecraft.potion.effect.poison": "Strupeni napoj",
  "item.minecraft.potion.effect.regeneration": "Napoj regeneracije",
  "item.minecraft.potion.effect.slow_falling": "Napoj počasnega padanja",
  "item.minecraft.potion.effect.slowness": "Napoj počasnosti",
  "item.minecraft.potion.effect.strength": "Napoj moči",
  "item.minecraft.potion.effect.swiftness": "Napoj hitrosti",
  "item.minecraft.potion.effect.thick": "Gost napoj",
  "item.minecraft.potion.effect.turtle_master": "Napoj mojstra želv",
  "item.minecraft.potion.effect.water": "Steklenica vode",
  "item.minecraft.potion.effect.water_breathing": "Napoj podvodnega dihanja",
  "item.minecraft.potion.effect.weakness": "Napoj šibkosti",
  "item.minecraft.potion.effect.weaving": "Napoj pletenja",
  "item.minecraft.potion.effect.wind_charged": "Napoj vetrovne nabitosti",
  "item.minecraft.pottery_shard_archer": "Lončen drobec strelca",
  "item.minecraft.pottery_shard_arms_up": "Lončen drobec rok v zrak",
  "item.minecraft.pottery_shard_prize": "Lončen drobec nagrade",
  "item.minecraft.pottery_shard_skull": "Lončen drobec lobanje",
  "item.minecraft.powder_snow_bucket": "Vedro s prašnim snegom",
  "item.minecraft.prismarine_crystals": "Kristali morske prizme",
  "item.minecraft.prismarine_shard": "Košček morske prizme",
  "item.minecraft.prize_pottery_shard": "Lončen drobec nagrade",
  "item.minecraft.prize_pottery_sherd": "Lončen drobec nagrade",
  "item.minecraft.pufferfish": "Napihovalka",
  "item.minecraft.pufferfish_bucket": "Vedro z napihovalko",
  "item.minecraft.pufferfish_spawn_egg": "Jajček z napihovalko",
  "item.minecraft.pumpkin_pie": "Bučna pita",
  "item.minecraft.pumpkin_seeds": "Bučna semena",
  "item.minecraft.purple_bundle": "Vijolična vreča",
  "item.minecraft.purple_dye": "Vijolično barvilo",
  "item.minecraft.purple_harness": "Vijolična oprsnica",
  "item.minecraft.quartz": "Netherni kremen",
  "item.minecraft.rabbit": "Surov zajec",
  "item.minecraft.rabbit_foot": "Zajčja taca",
  "item.minecraft.rabbit_hide": "Zajčja koža",
  "item.minecraft.rabbit_spawn_egg": "Jajček z zajcem",
  "item.minecraft.rabbit_stew": "Zajčja obara",
  "item.minecraft.raiser_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Jajček z uničevalcem",
  "item.minecraft.raw_copper": "Surovi baker",
  "item.minecraft.raw_gold": "Surovo zlato",
  "item.minecraft.raw_iron": "Surovo železo",
  "item.minecraft.recovery_compass": "Obnovitveni Kompas",
  "item.minecraft.red_bundle": "Rdeča vreča",
  "item.minecraft.red_dye": "Rdeče barvilo",
  "item.minecraft.red_harness": "Rdeča oprsnica",
  "item.minecraft.redstone": "Redstone prah",
  "item.minecraft.resin_brick": "Smolna opeka",
  "item.minecraft.resin_clump": "Kepa smole",
  "item.minecraft.rib_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rebrasti oklep",
  "item.minecraft.rotten_flesh": "Gnilo meso",
  "item.minecraft.saddle": "Sedlo",
  "item.minecraft.salmon": "Surovi losos",
  "item.minecraft.salmon_bucket": "Vedro s lososom",
  "item.minecraft.salmon_spawn_egg": "Jajček z lososom",
  "item.minecraft.scrape_pottery_sherd": "Lončen drobec rezila",
  "item.minecraft.scute": "Luska",
  "item.minecraft.sentry_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Obliovana oklepna obloga",
  "item.minecraft.sheaf_pottery_shard": "Lončen drobec snopa",
  "item.minecraft.sheaf_pottery_sherd": "Lončen drobec snopa",
  "item.minecraft.shears": "Škarje",
  "item.minecraft.sheep_spawn_egg": "Jajček z ovco",
  "item.minecraft.shelter_pottery_shard": "Lončen drobec zavetja",
  "item.minecraft.shelter_pottery_sherd": "Lončen drobec zavetja",
  "item.minecraft.shield": "Ščit",
  "item.minecraft.shield.black": "Črn ščit",
  "item.minecraft.shield.blue": "Moder ščit",
  "item.minecraft.shield.brown": "Rjav ščit",
  "item.minecraft.shield.cyan": "Turkizen ščit",
  "item.minecraft.shield.gray": "Siv ščit",
  "item.minecraft.shield.green": "Zelen ščit",
  "item.minecraft.shield.light_blue": "Svetlo moder ščit",
  "item.minecraft.shield.light_gray": "Svetlo siv ščit",
  "item.minecraft.shield.lime": "Svetlo zelen ščit",
  "item.minecraft.shield.magenta": "Škrlaten ščit",
  "item.minecraft.shield.orange": "Oranžen ščit",
  "item.minecraft.shield.pink": "Roza ščit",
  "item.minecraft.shield.purple": "Vijoličen ščit",
  "item.minecraft.shield.red": "Rdeč ščit",
  "item.minecraft.shield.white": "Bel ščit",
  "item.minecraft.shield.yellow": "Rumen ščit",
  "item.minecraft.shulker_shell": "Shulkerjev oklep",
  "item.minecraft.shulker_spawn_egg": "Jajček s shulkerjem",
  "item.minecraft.sign": "Znak",
  "item.minecraft.silence_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Tiha oklepna obloga",
  "item.minecraft.silverfish_spawn_egg": "Jajček s ščetinorepko",
  "item.minecraft.skeleton_horse_spawn_egg": "Jajček z okostnjaškim konjem",
  "item.minecraft.skeleton_spawn_egg": "Jajček z okostnjakom",
  "item.minecraft.skull_banner_pattern": "Vzorec za zastave",
  "item.minecraft.skull_banner_pattern.desc": "Gusarski znak",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Lončen drobec lobanje",
  "item.minecraft.skull_pottery_sherd": "Lončen drobec lobanje",
  "item.minecraft.slime_ball": "Sluzasta krogla",
  "item.minecraft.slime_spawn_egg": "Jajček s sluzjo",
  "item.minecraft.smithing_template": "Kovačeva predloga",
  "item.minecraft.smithing_template.applies_to": "Se upošteva pri:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Dodaj palico ali kristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Oklep",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Dodaj kos oklepa",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Palice in kristali",
  "item.minecraft.smithing_template.ingredients": "Sestavine:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Dodaj palico netherita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantna oprema",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Dodaj diamantni oklep, orožje, ali orodje",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheritna palica",
  "item.minecraft.smithing_template.upgrade": "Nadgradnja: ",
  "item.minecraft.sniffer_spawn_egg": "Jajček s snifferjem",
  "item.minecraft.snort_pottery_shard": "Lončen drobec smrčanja",
  "item.minecraft.snort_pottery_sherd": "Lončen drobec smrčanja",
  "item.minecraft.snout_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Oklep za gobec",
  "item.minecraft.snow_golem_spawn_egg": "Jajček s snežnim golemom",
  "item.minecraft.snowball": "Snežena kepa",
  "item.minecraft.spectral_arrow": "Fantomska puščica",
  "item.minecraft.spider_eye": "Pajkovo oko",
  "item.minecraft.spider_spawn_egg": "Jajček s pajkom",
  "item.minecraft.spire_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Oklep Spire",
  "item.minecraft.splash_potion": "Škropilni napoj",
  "item.minecraft.splash_potion.effect.awkward": "Osnovni škropilni napoj",
  "item.minecraft.splash_potion.effect.empty": "Škropilni neustvarljiv napoj",
  "item.minecraft.splash_potion.effect.fire_resistance": "Škropilni napoj odpornosti proti ognju",
  "item.minecraft.splash_potion.effect.harming": "Škropilni napoj škodovanja",
  "item.minecraft.splash_potion.effect.healing": "Škropilni napoj zdravljenja",
  "item.minecraft.splash_potion.effect.infested": "Škropilni napoj okuženja",
  "item.minecraft.splash_potion.effect.invisibility": "Škropilni napoj nevidnosti",
  "item.minecraft.splash_potion.effect.leaping": "Škropilni napoj skakanja",
  "item.minecraft.splash_potion.effect.levitation": "Škropilni napoj lebdenja",
  "item.minecraft.splash_potion.effect.luck": "Škropilni napoj sreče",
  "item.minecraft.splash_potion.effect.mundane": "Preprosti škropilni napoj",
  "item.minecraft.splash_potion.effect.night_vision": "Škropilni napoj nočnega vida",
  "item.minecraft.splash_potion.effect.oozing": "Škropilni napoj iztekanja",
  "item.minecraft.splash_potion.effect.poison": "Škropilni napoj strupa",
  "item.minecraft.splash_potion.effect.regeneration": "Škropilni napoj regeneracije",
  "item.minecraft.splash_potion.effect.slow_falling": "Škropilni napoj počasnega padanja",
  "item.minecraft.splash_potion.effect.slowness": "Škropilni napoj počasnosti",
  "item.minecraft.splash_potion.effect.strength": "Škropilni napoj moči",
  "item.minecraft.splash_potion.effect.swiftness": "Škropilni napoj hitrosti",
  "item.minecraft.splash_potion.effect.thick": "Gost škropilni napoj",
  "item.minecraft.splash_potion.effect.turtle_master": "Škropilni napoj mojstra želv",
  "item.minecraft.splash_potion.effect.water": "Škropilna steklenička vode",
  "item.minecraft.splash_potion.effect.water_breathing": "Škropilni napoj podvodnega dihanja",
  "item.minecraft.splash_potion.effect.weakness": "Škropilni napoj šibkosti",
  "item.minecraft.splash_potion.effect.weaving": "Škropilni napoj pletenja",
  "item.minecraft.splash_potion.effect.wind_charged": "Škropilni napoj vetrovne nabitosti",
  "item.minecraft.spruce_boat": "Smrekov čoln",
  "item.minecraft.spruce_chest_boat": "Smrekov čoln s skrinjo",
  "item.minecraft.spyglass": "Ročni teleskop",
  "item.minecraft.squid_spawn_egg": "Jajček z lignjem",
  "item.minecraft.stick": "Palica",
  "item.minecraft.stone_axe": "Kamnita sekira",
  "item.minecraft.stone_hoe": "Kamnita motika",
  "item.minecraft.stone_pickaxe": "Kamnit kramp",
  "item.minecraft.stone_shovel": "Kamnita lopata",
  "item.minecraft.stone_spear": "Kamnita Kopija",
  "item.minecraft.stone_sword": "Kamnit meč",
  "item.minecraft.stray_spawn_egg": "Jajček z brezdomcem",
  "item.minecraft.strider_spawn_egg": "Jajček s striderjom",
  "item.minecraft.string": "Vrvica",
  "item.minecraft.sugar": "Sladkor",
  "item.minecraft.suspicious_stew": "Sumljiva juha",
  "item.minecraft.sweet_berries": "Sladke jagode",
  "item.minecraft.tadpole_bucket": "Vedro s paglavcem",
  "item.minecraft.tadpole_spawn_egg": "Jajček s paglavcem",
  "item.minecraft.tide_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Oprijet oklep",
  "item.minecraft.tipped_arrow": "Strupena puščica",
  "item.minecraft.tipped_arrow.effect.awkward": "Pomakana puščica",
  "item.minecraft.tipped_arrow.effect.empty": "Neustvarljiva strupena puščica",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Puščica odpornosti proti ognju",
  "item.minecraft.tipped_arrow.effect.harming": "Puščica škodovanja",
  "item.minecraft.tipped_arrow.effect.healing": "Puščica zdravljenja",
  "item.minecraft.tipped_arrow.effect.infested": "Puščica okuženja",
  "item.minecraft.tipped_arrow.effect.invisibility": "Puščica nevidnosti",
  "item.minecraft.tipped_arrow.effect.leaping": "Puščica skakanja",
  "item.minecraft.tipped_arrow.effect.levitation": "Puščica lebdenja",
  "item.minecraft.tipped_arrow.effect.luck": "Puščica sreče",
  "item.minecraft.tipped_arrow.effect.mundane": "Pomakana puščica",
  "item.minecraft.tipped_arrow.effect.night_vision": "Puščica nočnega vida",
  "item.minecraft.tipped_arrow.effect.oozing": "Puščica iztekanja",
  "item.minecraft.tipped_arrow.effect.poison": "Strupena puščica",
  "item.minecraft.tipped_arrow.effect.regeneration": "Puščica regeneracije",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Puščica počasnega padanja",
  "item.minecraft.tipped_arrow.effect.slowness": "Puščica počasnosti",
  "item.minecraft.tipped_arrow.effect.strength": "Puščica moči",
  "item.minecraft.tipped_arrow.effect.swiftness": "Puščica hitrosti",
  "item.minecraft.tipped_arrow.effect.thick": "Pomakana puščica",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Puščica mojstra želv",
  "item.minecraft.tipped_arrow.effect.water": "Puščica škropljenja",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Puščica podvodnega dihanja",
  "item.minecraft.tipped_arrow.effect.weakness": "Puščica šibkosti",
  "item.minecraft.tipped_arrow.effect.weaving": "Puščica pletenja",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Puščica vetrovne nabitosti",
  "item.minecraft.tnt_minecart": "Voziček z dinamitom",
  "item.minecraft.torchflower_seeds": "Semena baklinega cveta",
  "item.minecraft.totem_of_undying": "Totem neumiranja",
  "item.minecraft.trader_llama_spawn_egg": "Jajček s trgovčevo lamo",
  "item.minecraft.trial_key": "Preizkusni ključ",
  "item.minecraft.trident": "Trizob",
  "item.minecraft.tropical_fish": "Tropska riba",
  "item.minecraft.tropical_fish_bucket": "Vedro s tropsko ribo",
  "item.minecraft.tropical_fish_spawn_egg": "Jajček s tropsko ribo",
  "item.minecraft.turtle_helmet": "Želvin oklep",
  "item.minecraft.turtle_scute": "Želvja luska",
  "item.minecraft.turtle_spawn_egg": "Jajček z želvo",
  "item.minecraft.vex_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex oklep",
  "item.minecraft.vex_spawn_egg": "Jajček z vexom",
  "item.minecraft.villager_spawn_egg": "Jajček z vaščanom",
  "item.minecraft.vindicator_spawn_egg": "Jajček z maščevalcem",
  "item.minecraft.wandering_trader_spawn_egg": "Jajček s potujočim trgovcem",
  "item.minecraft.ward_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Oddelčni oklep",
  "item.minecraft.warden_spawn_egg": "Jajček z wardenom",
  "item.minecraft.warped_fungus_on_a_stick": "Popačena goba na palici",
  "item.minecraft.water_bucket": "Vedro vode",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Pšenica",
  "item.minecraft.wheat_seeds": "Pšenična semena",
  "item.minecraft.white_bundle": "Bela vreča",
  "item.minecraft.white_dye": "Belo barvilo",
  "item.minecraft.white_harness": "Bela oprsnica",
  "item.minecraft.wild_armor_trim_smithing_template": "Kovačeva predloga",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Naboj vetra",
  "item.minecraft.witch_spawn_egg": "Jajček s čarovnico",
  "item.minecraft.wither_skeleton_spawn_egg": "Jajček z wither okostnjakom",
  "item.minecraft.wither_spawn_egg": "Jajček s witherjem",
  "item.minecraft.wolf_armor": "Volčji oklep",
  "item.minecraft.wolf_spawn_egg": "Jajček z volkom",
  "item.minecraft.wooden_axe": "Lesena sekira",
  "item.minecraft.wooden_hoe": "Lesena motika",
  "item.minecraft.wooden_pickaxe": "Lesen kramp",
  "item.minecraft.wooden_shovel": "Lesena lopata",
  "item.minecraft.wooden_spear": "Lesena kopija",
  "item.minecraft.wooden_sword": "Lesen meč",
  "item.minecraft.writable_book": "Knjiga in pero",
  "item.minecraft.written_book": "Napisana knjiga",
  "item.minecraft.yellow_bundle": "Rumena vreča",
  "item.minecraft.yellow_dye": "Rumeno barvilo",
  "item.minecraft.yellow_harness": "Rumena oprsnica",
  "item.minecraft.zoglin_spawn_egg": "Jajček z Zoglinom",
  "item.minecraft.zombie_horse_spawn_egg": "Jajček z zombi konjem",
  "item.minecraft.zombie_nautilus_spawn_egg": "Jajček s zombi nautilisom",
  "item.minecraft.zombie_spawn_egg": "Jajček z zombijem",
  "item.minecraft.zombie_villager_spawn_egg": "Jajček z zombi vaščanom",
  "item.minecraft.zombified_piglin_spawn_egg": "Jajček z Zombificiranim Piglinom"
}
export const sl_si = items; 
